<template>
  <div style="position:relative">
    <files-browser v-if="browserType == 'fusion'" :enableAssetMultiSelect="true" :workspaceList="getWorkspacesList" @close="closeModal" @handleFilesBrowse="handleFilesBrowse"></files-browser>
      
      <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header p-2" style="width:100%;display:inline-block !important;">
                <!-- <h2 v-if="Object.keys(reviewDetails).length >0" class="modal-title">
                  <span class="review-id">{{reviewDetails.review_id}} </span>
                  : {{reviewDetails.review_title}}</h2> -->
                <li class="nav-item header-bar-task-window" style="position:relative;width: 45px !important;display: inline-block;list-style: none;float:inline-start">
                  <a class="nav-item nav-link d-inline-flex  dropdown-toggle pl-0" href="#" @click="checkIsUnsavedDescription"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="width:100% !important;display:inline-block !important"
                  :style="allowToEditTaskIssue==true?'pointer-events:none':'pointer-events:auto'">
                      <button class="btn"> 
                        <div style="float:inline-start;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                          <title>{{defaultTaskType}}</title>
                          <defs/>
                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                              <g id="bug" sketch:type="MSArtboardGroup">
                                  <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                      <rect id="Rectangle-36" :fill="defaultTaskType == 'Issue'?'#E5493A':defaultTaskType == 'Task'? '#008000' : '#03a8cd'" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                      <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                  </g>
                              </g>
                          </g>
                      </svg></div>
                            <svg v-if="!isClientUser() &&  (!enableEditMode || (enableEditMode  && this.defaultTaskType != 'Ticket'))" xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#7f7f7f" class="bi bi-caret-down-fill" viewBox="0 0 16 16" style="position:relative;top:3px;">
                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                          </svg>
                    </button>
                                <!-- <button-with-arrow :buttonName="'New'"></button-with-arrow> -->
                  </a>
                  <div v-show="!isClientUser() && (!enableEditMode || (enableEditMode  && this.defaultTaskType != 'Ticket'))" class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="border: 1px solid #424242;background-color: #282828 !important;top: -15px !important;inset-inline-start :-40px !important;">
                      <a class="dropdown-item p-2" v-on:click="onTypeFilterChange('Task')">
                        <div style="float:inline-start;margin-inline-end: 5px;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                    <title>{{$t('Task')}}</title>
                            <defs/>
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                    <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                        <rect id="Rectangle-36" fill="#008000" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                        <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                    </g>
                                </g>
                            </g>
                        </svg></div>
                        {{$t('Task')}}
                      </a>
                      <a class="dropdown-item p-2" v-on:click="onTypeFilterChange('Issue')">
                        <div style="float:inline-start;margin-inline-end: 5px;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                    <title>{{$t('Issue')}}</title>
                            <defs/>
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                    <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                        <rect id="Rectangle-36" fill="#E5493A" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                        <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                    </g>
                                </g>
                            </g>
                        </svg></div>
                        {{$t('Issue')}}
                      </a>
                      <a v-if="!enableEditMode" class="dropdown-item p-2" v-on:click="onTypeFilterChange('Ticket')">
                        <div style="float:inline-start;margin-inline-end: 5px;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                    <title>{{$t('Ticket')}}</title>
                            <defs/>
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                    <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                        <rect id="Rectangle-36" fill="#03a8cd" sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                        <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                    </g>
                                </g>
                            </g>
                        </svg></div>
                        {{$t('Ticket')}}
                      </a>
                  </div>
                </li>
                <li id="mainProjectsDropdown" :class="checkIfFromPipeline()?'disable-field':''" :style="enableEditMode == true && defaultTaskType != 'Ticket' ? 'display:none':'display:block'" style="width:auto;list-style-type:none;float:inline-start;height:100%;">
                  <div class="config-value" style="height:100%">
                      <div style="display: inline-flex;height:100%;" class="w-100">
                          <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                                  <Multiselect
                                  v-model="selectedProject"
                                  :options="allProjectsList"
                                  :searchable="false"
                                  :close-on-select="true"
                                  :allow-empty="false"
                                  label="project_name"
                                  deselectLabel=""
                                  selectLabel=""
                                  selectedLabel=""
                                  track-by="_id"
                                  placeholder="Select Project"
                                  @select="onProjectChange($event)"
                                  @open="checkIsUnsavedDescription"
                                  >
                                  <!-- style="pointer-events:none" -->
                                  <span slot="noResult">No results.</span>
                                  <template slot="singleLabel" slot-scope="{ option }">{{option.short_code?option.short_code:option.project_name}}</template>
                              </Multiselect>
                          </div>
                      </div>       
                  </div>
                </li>
                <h2 class="review-title-heading" v-if="enableEditMode != true"> <input class="review-heading-input" v-model="taskTitle" type="text" :placeholder="defaultTaskType =='Issue'?'Enter Issue title': defaultTaskType =='Task'? 'Enter Task title' : 'Enter Ticket title'" id="task_title_field"> </h2>  
                <div v-else style="width:80%;display: inline-block;height:100%;"> 
                  <div class="w-100" style="width:100% !important">
                    <div class="d-inline-flex edit-icon-visibility">
                      <span v-show="!isTitleEditing" :title="reviewDetails.title" style="font-size:28px;display: inline-block;position:relative;top:7px;margin-inline-end:10px;word-break: break-word;user-select: text !important; cursor:text;">{{reviewDetails.task_tag}}: {{
                        reviewDetails.title
                      }} </span>

                      
                      <edit-icon
                        @click.native="editBasicInfoField(reviewDetails.title), checkIsUnsavedDescription()"
                        v-show="!isTitleEditing"
                        class="edit-icon"
                      ></edit-icon>

                    </div>
                    <input
                      minlength="3"
                      type="text"
                      v-model="titleValue"
                      v-show="isTitleEditing"
                      @click="checkIsUnsavedDescription()"
                      class="rounded text-light comm-input-field-style review-heading-input"
                      placeholder="Enter Title"
                      style="height: 55px;position: relative;bottom: 23px;font-size: 28px;width:95% !important"
                      required
                    />
                  </div>
                  <div v-show="isTitleEditing" class="taskTitleSaveUnsaveBtns">
                    <div class="d-flex">
                      <save-icon
                       @click.native="updateTaskFields('title', titleValue)"
                      ></save-icon>
                      
                      <cancel-icon
                        @click.native="cancelSelectedReviewFields('title')" >
                      </cancel-icon>
                    </div>
                  </div>
              </div>  
               
                <div style="float:inline-end">
                  <svg id="DAM-share_tasks_issues_in_chat" v-if="enableEditMode && isEnabled('Chat') && !isClientUser()" @click="shareUrlInChat()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#939393" class="bi bi-share-fill share-in-chat-styles" viewBox="0 0 16 16">
                    <title>{{$t('Share in chat')}}</title>
                    <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                  </svg>
                  <svg @click="closeModel()" width="3em" height="2.5em" viewBox="0 0 16 16" class="bi bi-x" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </div>
              </div>
              <div class="modal-body">
                <div class="filters-wrapper" v-if="showFilterOnTickets">
                  <!-- <review-filters :disableAll="true"  @getFilteredData="getFilteredData" @filterType="filterType" :enableEditMode= enableEditMode :selecetdtaskInfo='enableEditMode? reviewDetails : {}'></review-filters> -->
                
                <task-filter
                 :disableAll="true" 
                 :selectedProjectFromTicket="selectedProject"
                  @getFilteredData="getFilteredData"
                  @checkIsUnsavedDescription="checkIsUnsavedDescription" 
                  :filterContext="currentContext" 
                  @filterType="filterType" 
                  :allowToEditTaskIssue="enableEditMode" 
                  :selecetedTaskInfo='enableEditMode? reviewDetails : {}'
                  :filtersNotRequiredList="defaultTaskType == 'Ticket'? ['start_date', 'due_date'] : []"
                  :enableEditMode="enableEditMode"
                  :projectUsersList="selectedProjectUsersList">
                </task-filter>

                <span v-if="Object.keys(reviewDetails).includes('created_by_name') && reviewDetails.created_by_name.length > 0 && !isClientUser()" style="width: auto;display: inline-flex;float: inline-end;height: 100%;align-items: center;margin-inline-end: 20px;">
                    <label style="float: inline-start;margin-bottom: 0px !important;margin-inline-end:4px;color:#999">Created By : </label>
                    <div class="user-name-align">{{ reviewDetails.created_by_name}}</div>
                </span> 
                </div>
                <div class="video-wrapper d-flex" :style="enableEditMode == true?'height: calc(100% - 50px)':'height: calc(100% - 50px - 50px);' ">
                  <div class="col-8 d-block" style="margin: 0;height:100%">
                   
                    <div class="w-100 h-100 d-flex">
                      <!-- <div v-if="isTicket != true && this.defaultTaskType != 'Ticket'" class="col-2 clipboard-main-wrapper">
                          <div class="close-or-min-panel" style="height:40px;padding:6px">
                              <div class="heading p-0" style="width:100%;">Media</div>
                              <button class="btn btn-outline-primary button-styles" style="height: 25px;width: 25px;font-size: 14px;padding: 0;">
                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-left-quote" viewBox="0 0 16 16">
                                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                                <path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/>
                              </svg>
                              </button>
                          </div>
                          <div class="clipboardwrapper">
                              <div class="clipboard-card">
                                  <ul>
                                    <template v-for="file in assets">    
                                      <li v-if="file" :key="file._id" :class="{activeFile:activeFileIndex == file.file_uid}"  :id="file.file_uid"  v-on:dblclick="openPictureInPicture(file)" v-on:click="loadCommentsForSelectedFile(file.file_uid)" style="position:relative;width:100%">
                                          <div class="file-main-div" style="width:99%;display:inline-block;padding:8px 4px;">
                                              <div style="height: 55px;display: flex;width: 100%;justify-content: center">
                                              <img draggable="false" :src="getThumbnail(file)" @error="replaceByDefaultImage" style="border-radius: 5px;"/> 
                                              </div>
                                              <div style=" margin-top: 7px; text-align: center;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:11px" :title="file.slug_name">{{file.slug_name}}</div>
                                            </div>
                                          <div class="dropdown addedMediaFilesDiv" :style='assets.length == 1?"inset-inline-end:0px":"inset-inline-end:-46px"' style="position:absolute;top:2px;">
                                            
                                            <div
                                                class="nav-item nav-link dropdown-toggle mr-md-2"
                                                id="bd-versions"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="true"
                                                style="float: inline-end;padding: 0px !important;width: 38px !important;display: inline-block;margin: 0px !important;"
                                                >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots-vertical context-menu" viewBox="0 0 16 16">
                                                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                                </svg>                                              
                                              </div>
                                              <div
                                              class="dropdown-menu dropdown-menu-md-right p-0"
                                              aria-labelledby="bd-versions"
                                              style="inset-inline-start:30px !important;"
                                              >
                                                <a class="dropdown-item p-2" @click="editMediaAndAddComment(file)" style="font-size:11px !important">
                                                  Edit media</a>
                                              </div>
                                              <div class="individualFileEditIconDiv">
                                                 <svg @click="editMediaAndAddComment(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square context-menu" viewBox="0 0 16 16">
                                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                      <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                                    </svg>
                                              </div>  

                                            </div>
                                      </li>
                                    </template>  
                                  </ul>
                              </div>
                          </div>
                      </div> -->
                      <div class="col-md-12">
                          <div class="navbar-wrapper">
                              <nav class="navbar navbar-expand-lg p-0">
                                  <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                                      <div class="navbar-nav w-100 top-nav-bar">
                                          <a class="nav-item nav-link" @click="switchDetailsAndCommentTab('details')" :class='(activeIndex === "details")?"active":"inactive"' style="width:15% !important">{{$t('Details')}}</a>
                                          <a class="nav-item nav-link" @click="switchDetailsAndCommentTab('comments'); checkIsUnsavedDescription()" :class='(activeIndex === "comments")?"active":"inactive"' style="width:15% !important">{{$t('Comments')}}</a>
                                          <a v-if="enableEditMode && !isClientUser()" class="nav-item nav-link" @click="switchDetailsAndCommentTab('history'); checkIsUnsavedDescription()" :class='(activeIndex === "history")?"active":"inactive"' style="width:15% !important">{{$t('History')}}</a>
                                          <div class="comments-details-wrapper">
                                          <div v-if="Object.keys(reviewDetails).length >0" style="margin:10px;color: #828202;">{{$t('Last updated')}}: {{getDateAndTimeInConfiguredFormat(reviewDetails.modified_datetime)}}</div>
                                          <!-- <div class="search-bar-comm-style" style="display:inline-flex">
                                                  <Multiselect
                                                  :value="selectedSortByOption.label"
                                                  :options="sortByOptions"
                                                  :searchable="false"
                                                  :close-on-select="true"
                                                  :allow-empty="false"
                                                  @select="updateSortByOption($event)"
                                                  :label="label"
                                                  deselectLabel=""
                                                  selectLabel=""
                                                  selectedLabel=""
                                                  placeholder="Sort by"
                                                  :track-by="type">
                                                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                  <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                  </div>
                                                  <span slot="noResult">No results.</span>
                                              </Multiselect>
                                          </div> -->
                                          </div>
                                      </div>
                                  </div>
                              </nav>
                          </div>
                          <div class="contents-wrapper">
                              <div v-show="activeIndex == 'details'" class="description-section">
                                  <div class="common-input-field description-edit-icon-visibility" style="margin-top:7px;position:relative">
                                      <label class="comm-lable-styles">{{$t('Description')}}</label>
                                      <div v-if="isDescriptionEditing != true && enableEditMode == true" class="desc-text-cursor" style="max-height:200px;overflow:auto;"> 
                                       <span v-html="urlify(description)" style="white-space: pre-wrap;"></span>
                                        <!-- <edit-icon
                                          @click.native="editBasicInfoDescription(reviewDetails.description)"
                                          v-show="!isTitleEditing"
                                          class="edit-icon"
                                          style="margin-inline-start:10px;"
                                        ></edit-icon> -->
                                        <div class="description-options-wrapper">
                                          <svg @click="editBasicInfoDescription(reviewDetails.description)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                          </svg>
                                        </div>
                                      </div>

                                      <!-- @keydown='editMessageEnabled?updateMessage($event):sendMessageOrReply($event)' -->
                                      <div v-if="showMentions && isClientUser() == false" ref="scrollContainer" class='mentions-wrapper'>
                                          <div ref="test" v-for="(uItem, index) in filteredDropdown" :key="uItem._id" v-on:click="selectUserToBeMentioned(uItem)" :class="{ focusElement: index === focus }" class="mentions-option">
                                              <div v-if="Object.keys(uItem).includes('profile_image') && !['undefined',null].includes(uItem.profile_image) && uItem.profile_image" class='user-name-or-image' style="margin-inline-end: 9px;">
                                                  <img :src="getProxyConvertedURL(uItem.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                              </div>
                                              <div v-else class="user-name-or-image user-name" :style="style(uItem.username)" style="margin-inline-end: 9px;">{{ uItem.username.split("")[0] }}
                                              </div> 
                                              <div style="display: flex;align-items: center;">{{uItem.username}}</div>
                                          </div>
                                      </div> 
                                      <textarea 
                                        v-if="isDescriptionEditing == true &&  enableEditMode == true" 
                                        v-model="description" 
                                        @keyup.delete="detectBackspace($event)" 
                                        v-on:keypress="checkForMentions($event)" 
                                        @keydown="selectElementsThroughKeys($event)"
                                        ref='descriptionArea'
                                        @focus="showSaveUnsaveBts()"  
                                        type="text" placeholder="Add descripton here..." class="border rounded text-light w-100 taskDescriptionField"
                                      style="max-height:300px;min-height: 140px;padding: 4px;"></textarea> 

                                      <textarea 
                                        v-if="!enableEditMode && !isDescriptionEditing" 
                                        v-model="description"  
                                        @keyup.delete="detectBackspace($event)" 
                                        v-on:keypress="checkForMentions($event)" 
                                        @keydown="selectElementsThroughKeys($event)"
                                        ref='descriptionArea'
                                        type="text" 
                                        placeholder="Add descripton here..." 
                                        class="border rounded text-light w-100 taskDescriptionField"
                                      style="max-height:300px;min-height: 140px;padding: 4px;"></textarea> 
                                      
                                      <div v-show="isDescriptionEditing && enableEditMode">
                                        <div class="d-flex descriptionSaveUnsaveBtns"> 
                                            <!-- <save-icon
                                            @click.native="updateTaskFields('description',description)"
                                            style="background:#1c5c1c"
                                            ></save-icon> -->
                                            <button @click="updateTaskFields('description',description)" class="btn btn-primary btn-outline-primary button-styles" style="background: transparent;line-height: initial;margin-inline-end: 10px;">{{$t('Save')}}</button>
                                            <button @click="cancelSelectedReviewFields('description')" class="btn btn-primary button-styles" style="background: transparent;border-color: rgb(90, 90, 90);line-height: initial;">{{$t('Cancel')}}</button>

                                            <!-- <cancel-icon
                                            @click.native="cancelSelectedReviewFields('description')" 
                                            style="background:#a10d0d">
                                            </cancel-icon> -->
                                        </div>
                                      </div>
                                  </div>
                                  
                                  <div class="attachment-wrapper">
                                        <div v-show="isEnabled('Upload')" id="DAM-attach_media_in_description" class="comm-action-buttons-styles-on-tasks">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-paperclip" viewBox="0 0 16 16">
                                                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                                                </svg>
                                                {{$t('Attach')}}
                                            </span>
                                            <div style="position: absolute;top: 1%;inset-inline-start0%;opacity: 0;height:100%;width:100%">
                                                <input 
                                                    style="height:100%;width:100%"
                                                    type="file"
                                                    id="file"
                                                    ref="uploadFile"
                                                    multiple
                                                    @click="checkIsUnsavedDescription;resetImageUploader();"
                                                    v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                                  />
                                            </div>
                                        </div>
       <!--v-show="isTicket == true" --><div v-show="defaultTaskType == 'Ticket' && enableEditMode == true && !isClientUser()" id="DAM-clone_ticket" class="comm-action-buttons-styles-on-tasks">
                                           <div @click="cloneTicketAsIssue();">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-back" viewBox="0 0 16 16">
                                                  <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/>
                                                </svg>
                                                {{$t('Clone')}}
                                            </div>
                                        </div>
                                        <div v-show="!isClientUser()" id="DAM-link-type" class="comm-action-buttons-styles-on-tasks" style="width: 10%;display: inline-block;padding: 9px;text-align: center;">
                                           <div @click="linkTaskOrIssue();">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                                </svg>
                                                {{$t('Link')}}
                                            </div>
                                        </div>
                                        <!-- <div class="comm-action-buttons-styles-on-tasks" style="width:23%;">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-ui-checks" viewBox="0 0 16 16">
                                                    <path d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708l-2 2zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708l-2 2zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                                                </svg>
                                                Create Sub Task
                                            </span>
                                        </div> -->
                                  </div>

                                  
                                  <div class="attached-media-files-wrapper" style="padding:10px 15px">
                                    <svg  v-if="!showAttachments" v-on:click="showAttachments = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg>
                                    <svg v-if="showAttachments" v-on:click="showAttachments = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                      <label class="comm-lable-styles">{{$t('Attachments')}} <span v-if="attachedFilesArr.length > 0">({{attachedFilesArr.length}})</span></label>                                      
                                      <div v-if="showClone == true"> 
                                        <preview :previewDataFromParent="clonedData" :disbaleRedirect="false" style="padding-bottom:5px !important"></preview>
                                       
                                      <!--  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                          <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
                                          <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
                                          </svg> -->
                                      </div>
                                      
                                      <div style="height: auto;" v-show="showAttachments == true">
                                          <!-- attached files will show here -->
                                            <attach-file v-bind="attachmentData" :alreadyAttachedFiles="attachedFiles" uniqueId='tasksIssuesDescription' @openPipOfAttachment="openPipOfAttachment" @attachedFilesList="attachedFilesList" :enableDeleteIcon="true" :abortInProgressUpload="abortUpload" @abortedInProgressFiles="abortedInProgressFiles"></attach-file>
                                    
                                      </div>
                                  </div>
                                  <div v-show="!isClientUser()" class="linked-issues-main-wrapper" style="padding:10px 15px">
                                     <svg  v-if="!showLinkedTasks" v-on:click="showLinkedTasks = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                    </svg>
                                    <svg v-if="showLinkedTasks" v-on:click="showLinkedTasks = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>

                                    <label class="comm-lable-styles" style="width:95%;"> {{$t('Links')}}</label>
                                    <div class="linked-types-list-wrapper" v-if="showLinkedTasks && selectedLinkTypeList.length>0" style="padding: 5px 15px;">
                                      <template v-for="linkedObj in selectedLinkTypeList">
                                        <div :key="linkedObj._id" style="border-bottom: 1px solid #2c2c2c;padding: 5px 8px;">
                                          <label style="width: 25%;display: inline-block;float: inline-start;">{{getLInkTypeName(linkedObj.link_id).label}}</label>
                                          <div style="width:100%;display:inline-block">
                                            <!-- {{linkedObj.linked_info}} -->
                                            <template v-for="task1 in linkedObj.linked_info">
                                              <div class="preview-tag-main-wrapper" :key="task1.task_tag"> 
                                                <div class="preview-tag-div">
                                                  <preview :sentenceWithUrl="task1.preview_url" :disbaleRedirect="false" :isPreviewRequiredInSameTab="false" style="padding-bottom:5px !important;float:inline-start;display:inline-block;max-width:100%;"></preview>
                                                </div>
                                                <div class="url-preview-delete-icon" @click="deleteLinkedTaskOrIssue(linkedObj.link_id, task1)">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#989898" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                                  </svg>
                                                </div>  
                                              </div>
                                            </template>
                                          </div>
                                          <!-- <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                            </svg>
                                          </div> -->
                                        </div>
                                      </template>  
                                    </div>
                                    <div v-if="allowToAddNewLink"  class="linked-issues-list-wrapper" style="width:100%;display:inline-block">
                                      <div id="add-new-link-wrapper" style="width:25%;display:inline-block">
                                          <div class="d-inline-flex" style="width:100%;">
                                            <Multiselect
                                              v-model="selectedLInkType"
                                              :options="inWardOutWardLists"
                                              :searchable="false"
                                              :close-on-select="true"
                                              :allow-empty="false"
                                              label="label"
                                              deselectLabel=""
                                              selectLabel=""
                                              selectedLabel=""
                                              track-by="link_id"
                                              placeholder="Select Link Type"
                                              @select="onlinktypeChange($event)"
                                              @open="checkIsUnsavedDescription"
                                              >
                                              <!-- style="pointer-events:none" -->
                                              <span slot="noResult">No results.</span>
                                              <!-- <template slot="singleLabel" slot-scope="{ option }">{{option.short_code}}</template> -->
                                            </Multiselect>
                                          </div>
                                      </div>
                                      <div class="linking-tasks-browse-wrapper" style="width:75%;display:inline-block;">
                                        <div style="width:90%;display:inline-block;float:inline-start">
                                          <input type="text" :value="getSelectedTaskIds()" style="width: 100%; display: inline-block;border: 1px solid #4a4a4a;padding: 5px;border-radius: 5px;height: 38px;color:#fff"/>
                                        </div>
                                        <div style="width:10%;display:inline-block">
                                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-folder" viewBox="0 0 16 16">
                                            <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
                                          </svg> -->
                                          <div v-if="isEnabled('Ticket') || isEnabled('Projects')" id="DAM-insert_pam" class="nav-item show" style="inset-inline-start:2%;">
                                            <a class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="width: 38px !important;height: 38px !important;margin-inline-start: 10px;">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                              </svg>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                              <a v-if="isEnabled('Ticket')" class="dropdown-item p-2 d-flex" v-on:click="openPamBrowseOnClick('tickets')">
                                                  <div style="height:20px;width:20px">
                                                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                                          <defs/>
                                                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                          <g id="bug" sketch:type="MSArtboardGroup">
                                                          <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                                          <rect id="Rectangle-36" fill='#03a8cd' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                                          <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                                          </g>
                                                          </g>
                                                          </g>
                                                      </svg>
                                                  </div>
                                                  <span>{{$t('Tickets')}}</span>
                                              </a>
                                              <a v-if="isEnabled('Projects')"  class="dropdown-item p-2 d-flex" v-on:click="openPamBrowseOnClick('tasks')">
                                                  <div style="height:20px;width:20px">
                                                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                                          <defs/>
                                                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                          <g id="bug" sketch:type="MSArtboardGroup">
                                                          <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                                          <rect id="Rectangle-36" fill='#008000' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                                          <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                                          </g>
                                                          </g>
                                                          </g>
                                                      </svg>
                                                  </div>
                                                  <span>{{$t('Tasks')}}</span>
                                              </a>
                                              <a v-if="isEnabled('Projects')" class="dropdown-item p-2 d-flex" v-on:click="openPamBrowseOnClick('issues')">
                                                  <div style="height:20px;width:20px">
                                                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                                          <defs/>
                                                          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                          <g id="bug" sketch:type="MSArtboardGroup">
                                                          <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                                          <rect id="Rectangle-36" fill='#E5493A' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                                          <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                                          </g>
                                                          </g>
                                                          </g>
                                                      </svg>
                                                  </div>
                                                  <span>{{$t('Issues')}}</span>
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="add-link-buttons-wrapper" style="width: 100%; display: inline-block;margin-top: 16px;position: relative;padding-inline-end: 6%;">
                                        <button @click="addNewLinkTaskIssue" class="btn btn-primary btn-outline-primary button-styles" style="background: transparent;line-height: initial;margin-inline-start: 10px;float:inline-end">{{$t('Save')}}</button>
                                        <button @click="cancelLinkTaskIssue" class="btn btn-primary button-styles" style="background: transparent;border-color: rgb(90, 90, 90);line-height: initial;float:inline-end">{{$t('Cancel')}}</button>
                                      </div>
                                    </div>
                                   
                                  </div>
                                  
                                  <!-- <div class="sub-tasks-list-wrapper" style="padding:10px 15px">
                                      <label class="comm-lable-styles">Sub Tasks</label>
                                      <div style="height: 100px;background: #181818;">
                                           subtasks list will show here 
                                      </div>
                                  </div> -->
                              </div>
                              <div v-show="activeIndex == 'comments'" class="comments-section">
                                <div v-if="commentsListFromServer.length" v-on:scroll="loadMoreComments($event)" class="added-comments-wrapper" id="main_comments_wrapper" ref='mainCommentsWrapper' :style="{'height':resizedHeight}">
                                    <div v-for="comment in commentsListFromServer" :key="comment.comment_id">
                                        <!-- <comments :commentDetails="comment" :reviewDetails="indTaskInfo" @openThread="openReplyThread" @commentStatus="updatedcommentStatus" @commentDelete="deletingComment" :commentModule="commentModule"></comments> -->
                                      
                                      <!-- below line can be comment there till routing upat with Task/Issues -->
                                        <comments :commentDetails="comment" :reviewDetails="indTaskInfo" @openThread="openReplyCommentThread" @commentStatus="updatedcommentStatus" @commentDelete="deletingComment" :commentModule="commentModule" :isTicket="isTicket" @openPictureInPicture="openPictureInPicture" @openManageVersions="openManageVersions"></comments>
                                    
                                        <!-- <comments :commentDetails="comment" :reviewDetails="indTaskInfo" @openThread="isTicket == true ? openReplyCommentThread : openReplyThreadInTaskIssues" @commentStatus="updatedcommentStatus" @commentDelete="deletingComment" :commentModule="commentModule"></comments> -->
                                    
                                    </div>
                                </div>
                                <add-comment @postComment="commentInMainPanel" @commentPostData="postNewComment" :allowToAddComment= enableEditMode :selectedFilesList= assetsInfo attachmentContext='taskParentCommentAttachment' ref="comment-textarea" @openPipOfAttachment="openPipOfAttachment" :projectUsersList="selectedProjectUsersList"></add-comment>
                              </div>
                              <div v-show="activeIndex == 'history' && !isClientUser()" class="history-section">
                                <div v-if="historyData.length > 0" style="padding:20px;">  
                                  <template v-for="history in historyData">
                                      <div :key="history._id" class="each-history-main-wrapper">
                                        <div class="summary-div">
                                          <div style="display: inline-block;   justify-content: end;float: inline-start;margin-inline-end: 10px;">
                                              <div v-if="Object.keys(history).includes('profile_image') && !['undefined',undefined,null].includes(history.profile_image) && history.profile_image">
                                                  <div v-for="(value, key) in history.profile_image" :key="key"> 
                                                      <div v-if="!['undefined',undefined,null].includes(value)"> 
                                                          <div class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                                              <img :src="getProxyConvertedURL(history.profile_image[key])" @error="replaceWithUserIcon($event,history.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                          </div> 
                                                      </div>  
                                                      <div v-else class="user-name-or-image user-name" :style="style(history.username)" :title="history.username" style="top:0px !important">{{ history.username.split("")[0] }}</div>  
                                                  </div>       
                                              </div>
                                              <div v-else class="user-name-or-image user-name" :style="style(history.username)" :title="history.username" style="top:0px !important">{{ history.username.split("")[0] }}</div>
                                          </div>
                                          <span class="summary-data-div">{{getCapitalizedSummaryData(history.summary)}}</span>
                                          <span class="date-lael">{{getDateAndTimeInConfiguredFormat(history.action_datetime)}}</span>
                                        </div>
                                        <div class="detailed-information-wrapper">
                                          <!-- <pre style="padding-inline-start:40px;">{{getUpdatedDescriptionInfo(history.detailed_information)}}</pre> -->
                                          <template v-for=" history in getUpdatedDescriptionInfo(history.detailed_information)">
                                            <div :key="history" style="padding-inline-start:40px;width:100%;dispaly:inline-block;word-break:break-all">{{history}}</div>
                                          </template>  
                                        </div>
                                      </div>
                                  </template>
                                </div>
                                <div v-else>
                                  <div class="no-history-data">No History data</div>
                                </div>  
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel-three col-4" style="position:relative;height:100%%;width:100%;display:inline-block;height:100%">
                    <div v-if="isReplyThreadOpen" style="position:relative;height:100%;width:100%;display:inline-block">
                        <div class="close-or-min-panel">
                            <svg v-on:click="closeReplyThread()" xmlns="http://www.w3.org/2000/svg" width="40" height="40" style="position:relative;bottom:5px;color:#eee;margin-inline-end:11px" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                            </svg>
                            <div class="heading">{{$t('Comments')}}</div>
                            <!-- <button class="btn btn-outline-secondary button-styles">Annotate</button> -->
                        </div>
                        <div class="replay-comments-main-wrapper" ref='replyCommentWrapper' :style="{'max-height':resizeReplyPanelHeight}">
                          <div v-if="parentCommentThumbnailPath != null && this.parentCommentThumbnailPath != undefined" class="markinMarkoutImageWrapperINReplyThread" style="display: flex;margin: auto;justify-content: center;width:70%;width:70%;margin-top:10px;align-items: center;"> <!-- :style="parentCommentThumbnailPath != null && this.parentCommentThumbnailPath != undefined?'height:150px':'height:0px;'"-->
                              <img draggable="false" :src="getProxyConvertedURL(parentCommentThumbnailPath)"  @error="replaceByDefaultImage" style="width:100%;margin:0px !important"/> 
                              <button t="ejazbandar" data-mri="ttttuu" @click="openAnnotationEditor(parentCommentThumbnailPath)" class="btn btn-outline-secondary button-styles annotate-btn" style="position:absolute;display:none;">{{$t('Annotate')}}</button>
                          </div>
                          <div class="reply-comments-wrapper" id="reply_comment_wrapper" :style="parentCommentThumbnailPath != null && this.parentCommentThumbnailPath != undefined?'height:calc(100% - 115px)':'height:100%'" style="overflow:auto">
                           
                            <div v-if="!isTicket">  
                              <!-- <div v-for="comment in repliedCommetslist" :key="comment._id"> -->
                                <!-- <replyComment :commentDetails="comment" :enableMinimalData="true" :reviewDetails="indTaskInfo" @replyCommentDelete="deletingReplyComment" :idOfParentComment="parentCommentId != null? parentCommentId: ''" :commentModule="commentModule"></replyComment> -->
                               <!-- </div> -->
                              
                               <!-- :name="($route.name == 'task-info' || $route.name == 'board-reply-comments')? 'board-reply-comments' : isTicket == true? 'ticket-reply-review-comments' : defaultTaskType == 'Issue'? 'issue-reply-comments': 'task-reply-comments'" -->
                              <replyComment
                                :name="($route.name == 'tasks-window' || $route.name == 'board-reply-comments')? 'board-reply-comments' : isTicket == true? 'ticket-reply-review-comments' : defaultTaskType == 'Issue'? 'issue-reply-comments': 'task-reply-comments'"
                                :repliedCommetslist="repliedCommetslist"
                                :reviewInfo="indTaskInfo"  
                                @descriptionUpdate="descriptionUpdateByComments"
                                @replyCommentDelete="deletingReplyComment"
                                :parentCommentId="parentCommentId != null ? parentCommentId : ''"
                                :commentModule="commentModule"
                                :isTicket="isTicket"
                                :enableEditMode ="enableEditMode"
                                :previousDescription="previousDescription"
                                :updatedDescrption="description"
                                @openPictureInPicture="openPictureInPicture"
                                @openManageVersions="openManageVersions"
                              >
                              </replyComment>  
                             
                            </div>  

                            <div  v-else>
                              <router-view 
                                name="ticket-reply-review-comments"
                                :repliedCommetslist="repliedCommetslist"
                                :reviewInfo="indTaskInfo"
                                @checkIsUnsavedDescription="checkIsUnsavedDescription"  
                                @replyCommentDelete="deletingReplyComment"
                                :parentCommentId="parentCommentId != null ? parentCommentId : ''"
                                :commentModule="commentModule"
                                :isTicket="isTicket"
                                @openPictureInPicture="openPictureInPicture"
                                >
                              </router-view>
                            </div>
                          </div>  
                        </div>    
                        <add-comment @postComment="commentInThread" @replyPostData= "postNewReply" :allowToAddComment= enableEditMode :replyContext="true" :idOfParentComment="parentCommentId != null? parentCommentId: ''" attachmentContext='taskReplyCommentAttachment' ref="reply-comment-textarea" @openPipOfAttachment="openPipOfAttachment" :projectUsersList="selectedProjectUsersList"></add-comment>
                    </div>
                    <div v-else class="h-100">
                        <div class="close-or-min-panel" style="justify-content: flex-start;padding-inline-start: 8px;">
                            <div class="heading">{{$t('Fields')}}</div>
                        </div>
                       
                        <template v-if="enableEditMode">
                          <tagMetadata-fields
                          v-bind="selectedAssetInfo"
                          style="overflow:auto;height:calc(100% - 38px) !important"
                          :fixMinWidth="true"
                          :screenType="selectedScreenType()"
                          :enableOnlyFields="true"
                          :commentModule="commentModule"
                          :isTicket="isTicket"
                          :isDescriptionEditing="isDescriptionEditing"
                          @checkIsUnsavedDescription="checkIsUnsavedDescription"
                          ref="tagMetadataModel"></tagMetadata-fields>
                        </template>
                        <template v-else>
                          <metadata-fields style="overflow:auto;height:calc(100% - 38px) !important" :fixMinWidth="true" :screenType="selectedScreenType()" :enableMediaSlug="false" :enableOnlyFields="true" ref="sequenceMetadataModel"></metadata-fields>
                        </template>
                    </div>
                  </div>
                
                </div>
              </div>
              <div v-if="enableEditMode != true"  class="modal-footer p-0 primary-btn-style">
                <button class="btn btn-outline-primary button-styles"  @click.prevent="addNewTaskData()" style="float:inline-end">{{$t('Save')}}</button>
            </div>
            </div>
        </div>
      </div>
      <!-- <media-and-comment v-if="isPlayerOpen" :selectedFile="assetDetails" :parentComentsList="commentsListFromServer" @closeReviewMediaPanel="closeReviewMediaPanel" @commentwithmarkinmarkout="commentWithMarkinMarkout"></media-and-comment> -->
      <picture-in-picture v-if="openPip" :selectedFile="assetDetailsToShowPip" @maximisePlayer="showAssetDetailsDockCloseMaximisedplayer" :selectedModule="currentContext" @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
      <ImageAnnotationEditor :annotationData="annotationThumbnailPathNdAssetDetails" v-if="isAnnotationEditorVisible" @closeAnnotationEditor="isAnnotationEditorVisible = false"></ImageAnnotationEditor>
      <ImagePreviewDialog class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="assetDetailsToShowPip" @closeMiniPlayer="closeMinimisedPlayer" v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
      <description-reload-panel v-if="isDescriptionUpdated == true" @hideReloadPanelComponent="isDescriptionUpdated = false" @updateDescription="overWriteDescriptionValue"> </description-reload-panel>
      <!-- <Descrption-reload v-if="isDescReloadPanelComponentVisible"  @hideReloadPanelComponent="isDescReloadPanelComponentVisible = false"  @updateDescription="overWriteDescriptionValue"></Descrption-reload> -->
      <share-in-chat v-if="enableShareInChat" :url="routerUrlToShare" @close="closeShareInChat()"></share-in-chat>
      <manage-version v-if="openVersionDisplayDialog" @close="closeVersionDisplayDialog" :fileInfo="selectedFileToViewVersions" :disableUpload='true' @openPreviewOfMedia="openPreviewOfMedia"></manage-version>
    </div>
</template>


<script>
import comments from "./comments.vue"
import replyComment from "./PamReplyComment.vue"
import AddComment from "./AddCommentTextArea.vue"
import Multiselect from "vue-multiselect";
import {mapActions, mapGetters, mapMutations} from 'vuex';
import Utils from "../../components.utils.js";
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import Metadata from "../files/SequenceMetadata.vue";
import TagMetadata from "./ReviewMetadata.vue"
import PictureInPicture from "../files/MiniPlayer.vue";
// import MediaViewer from "./reviewMediaView.vue";
// import UpdateDropdowns from "./reviewUpdateDropdowns.vue";
import tasksFilter from "./FiltersForTaskIssues.vue";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import Constants from "../../components.constants.js";
// import review from '../../store/modules/review';
import Attachments from "../core/Attachments.vue";
// import ButtonWithArrow from "../core/ButtonWithArrowIcon.vue";
// import review from '../../store/modules/review';
import ImageAnnotationEditor from '../core/ImageAnnotationEditor.vue';
import ImagePreviewDialog from '../core/ImagePreviewDialog.vue';
import descriptionReloadPanel from './descriptionUpdateReloadPanel.vue';
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import shareInChat from "../core/ShareInChat.vue";
import tasksPreview from "../core/PreviewUrl.vue";
import fileBrowser from "../files/filesBrowse.vue";
import ManageVersionsDialog from "../ManageVersions/ManageVersionsDialog.vue";

export default {
  mixins:[RangeSliderMixins],
  // props :["taskContext" ,"enableEditMode", "taskInfo", "taskId", "fileInfo"] removed props while updating routing;
  props:["viewTask","isTicket", "taskDataFromChat", "backToParentRoute"],
  
  data() {
    return {
      enableEditMode : false,
      taskContext: 'Task',
      selectedFiles:{},
      selectedSingleFile:{},
      selectedMultipleFiles:{},
      selectedFilesPathsList: [],
      selectedProjectUsersList:[],
      selectedModalComponent:null,
      indTaskInfo:{},
      assetsInfo:{},
      assetDetails:{},
      assets:{},
      reviewDetails:{},
      description:"",
      previousDescription:"",
      isDescriptionUpdated:false,
      updateDescriptionOnRelaodText:"",
      taskTitle:"",
      mainComment:"",
      isTitleEditing:false,
      filteredData:{},
      commentsListFromServer:[],
      activeIndex:"details",
      activeFileIndex:null,
      selectedFileId: null,
      isPlayerOpen:false,
      isReplyThreadOpen:false,
      audioUrl:null,
      controller:{},
      openPip:false,
      videoOptions: {
        autoplay: false,
        controls: true,
        nativeTextTracks: true,
        controlBar:{
            'pictureInPictureToggle': false,
        },
            sources: []
        },
      noDataFoundImage:Utils.getNoDataFoundImg(),
      sortByOptions:[
      {label:"Oldest first",type:"Oldest first"},
      {label:"Newest first",type:"Newest first"},
      {label:"Most Relevent",type:"Most Relevent"},
      ],
      selectedSortByOption:{label:"Oldest first",type:"Oldest first"},
      titleValue : "",
      repliedCommetslist : [],
      parentCommentThumbnailPath : null,
      selectedFileUID : null,
      parentCommentId : null,
      isDescriptionEditing: false,
      selectedCommentThreadId: null,
      editingComment :null,
      currentContext:"Tasks",
      selectedFilesFromAttachments:null,
      attachedFilesArr:[],
      attachedFiles:[],
      defaultTaskType : "Task",
      selectedProject:null,
      showAttachments:true,
      showClone:false,
      clonedData:null,
      commentModule:"Task",
      assetDetailsToShowPip:{},
      isAnnotationEditorVisible:false,
      annotationThumbnailPathNdAssetDetails:{thumbnail:'',asset:{}},
      annotatedImagePath:'',
      showOtherFilesPreviewDialog:false,
      allowToEditTaskIssue:false,
      enableShareInChat:false,
      routerUrlToShare:null,
      resizeObservor:null,
      resizeReplyObserver:null,
      resizedHeight:"calc(100% - 145px)",
      resizeReplyPanelHeight:"calc(100% - 155px)",
      descriptionKeypressedForMention:'',
      showMentions:false,
      focus: null,
      parentRoute:{},
      abortUpload:false,
      emailRegex: new RegExp(/^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/),
      showLinkedTasks:true,
      linkTypeDataList:[],
      inWardOutWardLists:[],
      selectedLInkType:{},  
      browserType:"",
      chatBrowseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
      selectedLinkTasksIssuesList : [],
      selectedLinkTypeList :[],
      allowToAddNewLink:false,
      historyData:[],
      selectedFileToViewVersions:null,
      openVersionDisplayDialog:false
      // commentsListFromServer:[{
      //   "comment":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      //   "replied_by":["rashmi","admin","preethi"],
      //   "replies":4,
      //   "created_date":"2020-09-03T07:10:19",
      //   "state":"PENDING",
      //   "_id":"838476585888"
      // },
      // {
      //   "comment":"consectetur adipiscing elit, sed do eiusmod temporLorem ipsum dolor sit amet",
      //   "replied_by":["Kotresh"],
      //   "replies":0,
      //   "created_date":"Mon, 15 Nov 2021 12:05:07 GMT",
      //   "state":"COMPLETED",
      //   "_id":"838476585959"
      // }]
    };
  },
  components: {
    "comments":comments,
    "replyComment":replyComment,
    "add-comment":AddComment,
    "metadata-fields":Metadata,
    "tagMetadata-fields":TagMetadata,
    "Multiselect":Multiselect,
    "picture-in-picture":PictureInPicture,
    // "media-and-comment":MediaViewer,
    // "review-filters":UpdateDropdowns,
    "task-filter":tasksFilter,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "attach-file":Attachments,
    "description-reload-panel":descriptionReloadPanel,
    ImageAnnotationEditor,
    ImagePreviewDialog,
    "share-in-chat":shareInChat,
    // "button-with-arrow":ButtonWithArrow,
    'preview':tasksPreview,
    "files-browser":fileBrowser,
    "manage-version":ManageVersionsDialog
  },
  methods: {
    openManageVersions(file){
      this.openVersionDisplayDialog = true;
      this.selectedFileToViewVersions = file;
    },
    closeVersionDisplayDialog(){
        this.openVersionDisplayDialog = false;
        this.selectedFileToViewVersions = null;
    },
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    handleResize(){
       if(this.$refs["comment-textarea"] && this.$refs["comment-textarea"].$el != undefined){
            let height = this.$refs["comment-textarea"].$el.getBoundingClientRect().height;
            height = `calc(100% - ${height}px)`;
            this.resizedHeight  = height;
        }else{
            this.resizedHeight  = 'calc(100% - 145px)';
        }
    },
    handleReplyPanelResize(){
        if(this.$refs["reply-comment-textarea"].$el != undefined){
            let height = this.$refs["reply-comment-textarea"].$el.getBoundingClientRect().height;
            height = `calc(100% - ${height + 40}px)`;
            this.resizeReplyPanelHeight  = height;
        }else{
            this.resizeReplyPanelHeight  = 'calc(100% - 155px)';
        }
    },
    isEnabled(priv){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv)
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    shareUrlInChat(){
      this.enableShareInChat = true;
      this.routerUrlToShare = window.location.href;
    },
    closeShareInChat(){
      this.enableShareInChat = false;
    },
    closeAnnotationEditor(annotationImagePath){
      this.isAnnotationEditorVisible = false;
      this.annotatedImagePath = '';
      if(annotationImagePath && annotationImagePath != '') this.annotatedImagePath = annotationImagePath;
 /*      let index = this.commentsListFromServer.findIndex((obj) => obj.file_uid == this.activeFileIndex);
      let commentObject = this.commentsListFromServer[index];
      if(commentObject && commentObject.markers && commentObject.markers.frame_thumbnail_uri)  commentObject.markers.frame_thumbnail_uri = this.$refs.annotationEditor.getUploadedProxyThumbnailPath();
      this.$set(this.commentsListFromServer,index,commentObject); */
    },
    getUniqueId(){
      return Utils.getUUID();
    },  
    openAnnotationEditor(thumbnailPath){
         this.annotationThumbnailPathNdAssetDetails.thumbnail = thumbnailPath;
         this.annotationThumbnailPathNdAssetDetails.asset = this.assetDetails;
         this.isAnnotationEditorVisible = true;
    },
    //Attachments--------------------------------------------------
    resetImageUploader(){
      this.$refs.uploadFile.value = ''
    },

    getSelectedFileDetailsFromBrowse(){                 
      this.selectedFilesFromAttachments = this.$refs.uploadFile.files;
    },
    //-------------------------------------------------------------

    switchDetailsAndCommentTab(tabName){
      this.activeIndex = tabName;
      if(this.enableEditMode){
        let routName = "tasks-window";
        // if (this.$route.name == 'task-info' || this.$route.name == "board-reply-comments"){
        //   routName = "task-info";
        // }else if(this.$route.name == 'update-ticket' || this.$route.name == "ticket-reply-review-comments"){
        //   routName = "update-ticket";
        // }else if(this.$route.name == 'update-Issue' || this.$route.name == "issue-reply-comments"){
        //   routName = "update-Issue";
        // }else if(this.$route.name == 'update-task' || this.$route.name == "task-reply-comments"){
        //   routName = "update-task";
        // }

        let tabType1 = "de";
        if(tabName == "details"){
          tabType1 = "de";
        }else if(tabName == "comments"){
          tabType1 = "cm";
        }else if(tabName == "history"){
          tabType1 = "ht";
          this.getHistory();
        }else{
            if (this.$route.name == "ticket-reply-review-comments"){
              delete this.$route.params.ticketReplycommentId;
            }else if(this.$route.name == "board-reply-comments"){
              delete this.$route.params.boardReplycommentId;
            }else if(this.$route.name == "issue-reply-comments"){
              delete this.$route.params.issueReplycommentId;
            }else if(this.$route.name == "task-reply-comments"){
              delete this.$route.params.taskReplycommentId;
            }
        } 

        this.$router.push({
          name: routName,
          params:Object.assign(this.$route.params,{tabType:tabType1}),
          query:this.$route.query
        }); 
      } 
    },

    getHistory(){
      let payload = {};
      payload["taskId"] = this.reviewDetails.task_tag;
      this.getHistoryFromServer(payload).then((data) =>{
        this.historyData = data.history;
      });
    },

    getCapitalizedSummaryData(summary){
      return summary.charAt(0).toUpperCase() + summary.slice(1);
    },

    getUpdatedDescriptionInfo(info){
      const lines = info.replace("Changes:\n", "").split("\n");

      // Capitalize the first letter of each line
      // const capitalizedLines = lines.map(line => {
      //     return line.charAt(0).toUpperCase() + line.slice(1);
      // });

      // Join the lines back together with newlines
      // return capitalizedLines.join("\n");
      return lines;
    },

    descriptionUpdateByComments(descrptionParams){
      if(descrptionParams.isUpdateDescription == true){
        this.updateTaskFields('description',this.description)
      }else{
        this.description = this.previousDescription;
        this.isDescriptionEditing = false;
      }
    },

    checkIsUnsavedDescription(){
      if(this.enableEditMode == true && this.description != this.previousDescription && this.description!= null && this.previousDescription != null){
          if(confirm(
            `Unsaved Description is there, Do you want to save it ?`
          )){
            this.updateTaskFields('description',this.description);
          }else{
            this.description = this.previousDescription;
            this.isDescriptionEditing = false;
          }
      }
    },

    loadCommentsForSelectedFile(uid){
      this.selectedFileId = uid;
      this.activeFileIndex = uid;
    },

    showSaveUnsaveBts(){
      this.isDescriptionEditing = true;
    },

    getThumbnail(fileInfo = {}){
        return Utils.getThumbnailPathfromFileInfo(fileInfo);
    },

    selectedScreenType(){
      if(this.defaultTaskType == "Ticket"){
        if(this.isClientUser()){
          return "Customer Ticket"
        }else{
          return "Ticket"
        }
      }else{
        return "Task/Issue"
      }  
    },

    getMimeType(type) {
      let givenType = type.split("/")[0];
      if (givenType == "application") {
        givenType = "app";
      }
      return givenType;
    },

    editBasicInfoField(taskTitle){
      console.log(taskTitle) //don't remove
      this.isTitleEditing = true;
    },

    editBasicInfoDescription(){
      this.isDescriptionEditing = true;
    },

    editMediaAndAddComment(selectedInfo){
      this.isPlayerOpen = true;
      this.assetDetails = selectedInfo;
    },
    projectLabelCallback(option){
        return `${option.short_code}`
    },
    closeMinimisedPlayer(){
      this.openPip = false;
      this.showOtherFilesPreviewDialog = false
    },
    showAssetDetailsDockCloseMiniplayer(){
      if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
      this.openPip = true;
    },
    showAssetDetailsDockCloseMaximisedplayer(){
       if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }
    },
    closeReviewMediaPanel(){
      this.isPlayerOpen = false;
    },
    setController(controller){
        this.controller = controller
    },
    commentInThread(data){ // right threads section
      console.log("data----------1",data)
    },
    commentInMainPanel(data){ //Main winow
      console.log("data-----------2",data)
      this.mainComment = data;
    },

    onTypeFilterChange(selectedValue){
      this.defaultTaskType = selectedValue;
      this.commentModule = selectedValue;
      if(this.enableEditMode == true){
        this.updateTaskFields("task_type", selectedValue);
      }  
    },

    loadMoreComments(e){
      let commentsBodyHeight = this.$refs.mainCommentsWrapper.scrollHeight;
      let scrollBottom = this.$refs.mainCommentsWrapper.getBoundingClientRect().height + e.target.scrollTop; 
      let payload = {}, pageObj={};
      payload["task_id"] = this.indTaskInfo._id, payload;

      if (e.target.scrollTop == 0) {
        pageObj["comment_id"] = this.commentsListFromServer[0]._id;
        pageObj["direction"] = "prev";   
        payload.params = pageObj;
        payload.taskType = this.defaultTaskType;
        this.getServerCommentListData(payload).then((data) =>{
          let prevCommentList = data["comments"];
          this.commentsListFromServer = prevCommentList.concat(this.commentsListFromServer);
        }); 
      }else if(scrollBottom == commentsBodyHeight){  
        pageObj["comment_id"] = this.commentsListFromServer[this.commentsListFromServer.length - 1]._id;  
        pageObj["direction"] = "next";
        payload.params = pageObj;
        payload.taskType = this.defaultTaskType;
        this.getServerCommentListData(payload).then((data) =>{
            let prevCommentList = data["comments"];
            this.commentsListFromServer = this.commentsListFromServer.concat(prevCommentList);
        }); 
      }  
    },

    postNewComment(commentPostdata){
        let selectedReviewId = this.indTaskInfo._id;
        commentPostdata["file_uid"] =  this.selectedFileId;
        let payload = {};
        payload.reviewId = selectedReviewId;
        console.log('commentPostdata 2',commentPostdata);
       if(commentPostdata && Object.hasOwnProperty.call(commentPostdata,'markers') && this.annotatedImagePath != '') commentPostdata.markers.frame_thumbnail_uri =  this.annotatedImagePath;
       payload.params = commentPostdata;
       payload.taskType = this.defaultTaskType;
        this.addNewParentCommentForTask(payload).then((data) =>{
            // this.commentsListFromServer.push(data["comment"]);
            console.log(data);
        });
    },

    postNewReply(replayPostData){
       let selectedReviewId = this.indTaskInfo._id;
      let payload = {};
      payload.params = replayPostData;
      payload.reviewId = selectedReviewId;
      payload.taskType = this.defaultTaskType;
      this.addNewParentCommentForTask(payload).then((data) =>{
          console.log("checking posted reply", data);
          // this.repliedCommetslist.push(data["comment"])
      });
      

    },

    commentWithMarkinMarkout(commentNdMarkersData){
      console.log('commentNdMarkersData',commentNdMarkersData);
      let parentCommentObj = {};
      parentCommentObj["pid"] = "0";
      parentCommentObj["comment"] = commentNdMarkersData.comment;
      parentCommentObj["user_id"] = this.getLoggedInUserId();
      parentCommentObj["status"] = "Open"
      parentCommentObj['markers'] = commentNdMarkersData.markers;
      console.log('parentCommentObj',parentCommentObj);
      this.postNewComment(parentCommentObj);
    },

    onProjectChange(option){
        this.selectedProject = option;
        let payload = {}, params = {project_id:this.selectedProject._id};
        payload.params = params;
        this.getProjectsUsersFromServer(payload).then((data) =>{
          this.selectedProjectUsersList = data["users"];
        });

        if(this.taskContext == 'Ticket' && this.enableEditMode == true){
          this.filterType("project");

        }
        // if(option._id != "all"){
        //     if(option != null){
        //         this.requestingQueryParameters["project_id"] = option._id;
        //     }
        // }else{
        //     delete this.requestingQueryParameters.project_id;
        // }    
        // this.sendFilteredparametrs("project_id");    
    },


    closeModel(){
      if(this.enableEditMode){
        if(document.getElementsByClassName("upload-unInitialized") && document.getElementsByClassName("upload-unInitialized").length){
            if (confirm(`Upload not initialized, do you still want to close?`)) {
                this.abortUpload = true;
            }else{
                return false;
            }
        }
        if(document.getElementsByClassName("upload-in-progress") && document.getElementsByClassName("upload-in-progress").length){
            if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                return false;
            }else{
                this.abortUpload = true;
                return false;
            }
        }
      }else if(document.getElementsByClassName("upload-in-progress") && document.getElementsByClassName("upload-in-progress").length){
            this.abortUpload = true;
            return false;
      }
      // this.$emit("close");
      if (Object.keys(this.parentRoute)!=0 && Object.keys(this.parentRoute).includes("name") ){
        
        // if('taskId' in this.parentRoute.params && this.parentRoute.params.taskId){
        //   delete this.parentRoute.params.taskId;
        // }

        // if('tabType' in this.parentRoute.params && this.parentRoute.params.tabType){
        //   delete this.parentRoute.params.tabType;
        // }

        if('taskContext' in  this.parentRoute.query && this.parentRoute.query.taskContext 
            && this.parentRoute.query.taskContext == 'Ticket'){
              delete this.parentRoute.query.taskContext;
        }

        if('editMode' in  this.parentRoute.query && this.parentRoute.query.editMode 
            && this.parentRoute.query.editMode == 'Ticket'){
              delete this.parentRoute.query.editMode;
        }

        this.$router.push({
          name: this.parentRoute.name,
          params:this.parentRoute.params,
          query:Object.assign({}, this.parentRoute.query?this.parentRoute.query:{}),
        })
      }else{
        this.$router.push({
          name: "explorer",
        })
      }
    },
    abortedInProgressFiles(){
      this.$emit("close");
    },
    openPictureInPicture(fileInfo){
      this.assetDetailsToShowPip = fileInfo;
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }else{
        this.openPip = true;
        this.showOtherFilesPreviewDialog = false;
      }
    },
    isFullscreenPreviewAllowed(){
        let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
        return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.assetDetailsToShowPip)) > -1
    },
    openPipOfAttachment(fileInfo){
      this.openPictureInPicture(fileInfo)
    },
    closePlayer(){
      this.isPlayerOpen = false;
    },

    openReplyCommentThread(commentInfo){
      // this.annotationActiveCommentData = commentInfo;
      if(this.isTicket == true){
        this.$router.push({
          name:"ticket-reply-review-comments",
          params:Object.assign(this.$route.params,{ticketReplycommentId:commentInfo._id}),
          // params:{
          //   ticketReplycommentId:commentInfo._id,
          // },
          query:this.$route.query
        })
      }else if(this.$route.name == "board-reply-comments"){ //}else if(this.$route.name == "tasks-window" || this.$route.name == "board-reply-comments"){
        this.$router.push({
          name:"board-reply-comments",
          params:Object.assign(this.$route.params,{boardReplycommentId:commentInfo._id}),
          // params:{
          //   boardReplycommentId:commentInfo._id,
          // },
          query:this.$route.query
        })
      }else if(this.defaultTaskType == 'Issue' || this.defaultTaskType == 'Ticket'){
        // this.openReplyThread(commentInfo._id)
        this.$router.push({
          name:"issue-reply-comments",
          params:Object.assign(this.$route.params,{issueReplycommentId:commentInfo._id}),
          // params:{
          //   issueReplycommentId:commentInfo._id,
          // },
          query:this.$route.query
        })
      }else if(this.defaultTaskType == 'Task'){
        this.$router.push({
          name:"task-reply-comments",
          params:Object.assign(this.$route.params,{taskReplycommentId:commentInfo._id}),
          // params:{
          //   taskReplycommentId:commentInfo._id,
          // },
          query:this.$route.query
        })
      } 
    },


    openReplyThread(commentId){ ////this function is for - to pass the data of clicked comment's reply
     // do get based on selected reply - ID should be comment id which will come from comment info (commentInfo._id)
       this.selectedCommentThreadId = commentId;
        let payload = {};
        payload["commentId"] = commentId;
        payload["tasktype"] = this.defaultTaskType;
        this.getServerTaskCommetRepliesData(payload).then((data) =>{
            this.repliedCommetslist = data["comments"];
            this.parentCommentThumbnailPath = data["frame_thumbnail_uri"];
            for(let i=0; i<this.repliedCommetslist.length; i++){
              if(this.repliedCommetslist[i].pid == "0"){
                this.parentCommentId = this.repliedCommetslist[i]._id;
                break;
              } 
            }
            
        });
        this.isReplyThreadOpen = true; 
        this.$nextTick(() => {
            this.resizeReplyObserver = new ResizeObserver(() =>{
                // this.resizeObservor.disconnect();
                this.handleReplyPanelResize();
            });
            this.resizeReplyObserver.observe(this.$refs["reply-comment-textarea"].$el,{
                  childList: true,
                  subtree: true,
            });
        })
    },

     openReplyThreadInTaskIssues(commnetInfo){ ////this function is for - to pass the data of clicked comment's reply
     // do get based on selected reply - ID should be comment id which will come from comment info (commentInfo._id)
       this.selectedCommentThreadId = commnetInfo._id;
        let payload = {};
        payload["commentId"] = commnetInfo._id;
        payload["tasktype"] = this.defaultTaskType;

        this.getServerTaskCommetRepliesData(payload).then((data) =>{
            this.repliedCommetslist = data["comments"];
            this.parentCommentThumbnailPath = data["frame_thumbnail_uri"];
            for(let i=0; i<this.repliedCommetslist.length; i++){
              if(this.repliedCommetslist[i].pid == 0){
                this.parentCommentId = this.repliedCommetslist[i]._id;
                break;
              } 
            }
            
        });
        this.isReplyThreadOpen = true; 
        this.$nextTick(() => {
            this.resizeReplyObserver = new ResizeObserver(() =>{
                // this.resizeObservor.disconnect();
                this.handleReplyPanelResize();
            });
            this.resizeReplyObserver.observe(this.$refs["reply-comment-textarea"].$el,{
                  childList: true,
                  subtree: true,
            });
        })
    },

    updatedcommentStatus(commentsDetails){
        let payload={};
        // payload = this.proxyConfig;
        // payload.params = commentPostdata;
        let selectedReviewId = this.indTaskInfo._id;
        payload.reviewId = selectedReviewId;
        payload.commentModule = "Task"
        payload.taskType = this.defaultTaskType;
        let commentObj = {};
        commentObj["status"] = commentsDetails.status;
        commentObj["pid"] = commentsDetails.pid;
        commentObj["_id"] = commentsDetails._id;
        commentObj["edit"] = true;
        commentObj["user_id"] = commentsDetails.user_id;
        commentObj["comment"] = commentsDetails.comment;
        payload.params = commentObj
        this.updateCommentData(payload).then((data) => {
            if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                if(data.message) this.$toast.success(data.message);
            } else {
               if(data.message) this.$toast.error(data.message);
            }
        });
    },

    deletingComment(commentsDetails){
      if(commentsDetails.user_id == this.getLoggedInUserId()){
        if (confirm(`Are you sure you want to delete the Comment ?`)) {
          let payload={};
          let selectedCommentId = commentsDetails._id;
          payload.commentId = selectedCommentId;
          let commentObj = {};
          commentObj["review_id"] = this.indTaskInfo._id;
          commentObj["pid"] = "0";
          payload.params = commentObj;
          payload.taskType = this.defaultTaskType;
          this.deleteCommentFromTask(payload).then((data) => {
              
              // this.commentsListFromServer = this.commentsListFromServer.filter((comment)=>comment._id == selectedCommentId);

              if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                  if(data.message) this.$toast.success(data.message);
              } else {
                  if(data.message) this.$toast.error(data.message);
              }
          });     
        }   
      }else{
        this.$toast.error("Not allowed to delete Comment created by others.");
        return false;
      }
    },

    deletingReplyComment(deletingCommentInfo){
      if(deletingCommentInfo.user_id == this.getLoggedInUserId()){
        if (confirm(`Are you sure you want to delete the Comment ?`)) {
          let payload={};
          let selectedCommentId = deletingCommentInfo._id;
          payload.commentId = selectedCommentId;
          let commentObj = {};
          commentObj["review_id"] = this.indTaskInfo._id;
          commentObj["pid"] = deletingCommentInfo.pid;
          payload.params = commentObj;
          payload.taskType = this.defaultTaskType;
          this.deleteCommentFromTask(payload).then((data) => {
              
              // this.commentsListFromServer = this.commentsListFromServer.filter((comment)=>comment._id == selectedCommentId);

              if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                  if(data.message) this.$toast.success(data.message);
              } else {
                  if(data.message) this.$toast.error(data.message);
              }
          });     
        }   
      }else{
        this.$toast.error("Not allowed to delete Comment created by others.");
        return false;
      }
    },

    editCommentData(commentData){
      this.editingComment = commentData;
    },

    closeReplyThread(){ 
        let routName = "tasks-window";
        // if (this.$route.name == 'tasks-window' || this.$route.name == "board-reply-comments"){
        //   routName = "tasks-window";
        //   delete this.$route.params.ticketReplycommentId;
        // }else if(this.$route.name == 'update-ticket' || this.$route.name == "ticket-reply-review-comments"){
        //   routName = "update-ticket";
        //   delete this.$route.params.boardReplycommentId;
        // }else if(this.$route.name == 'update-Issue' || this.$route.name == "issue-reply-comments"){
        //   routName = "update-Issue";
        //   delete this.$route.params.issueReplycommentId;
        // }else if(this.$route.name == 'update-task' || this.$route.name == "task-reply-comments"){
        //   routName = "update-task";
        //   delete this.$route.params.taskReplycommentId;
        // }
        this.isReplyThreadOpen = false;
        this.$router.push({
          name:routName,
          params:Object.assign(this.$route.params,{taskId:this.indTaskInfo.task_tag},{tabType:this.$route.params.tabType}),
          query:this.$route.query
        });
    },

    getFilteredData(filtersdata){
      this.filteredData = filtersdata;
    },

    filterType(filterTypeValue){
      if(this.enableEditMode == true){
        if(filterTypeValue == "status"){
          this.updateTaskFields("status", this.filteredData.status);
        }else if(filterTypeValue == "priority"){
          this.updateTaskFields("priority", this.filteredData.priority);
        }else if(filterTypeValue == "assignee"){
          if(this.selectedProjectUsersList && this.selectedProjectUsersList.length>0){
            let isUserFound = this.selectedProjectUsersList.find(op=>op.user_id == this.filteredData.users);
            if(isUserFound){
              this.updateTaskFields("assignee_id", this.filteredData.users);
            }else{
              this.$toast.error(`Selected Assignee is not a part of Project '" ${this.selectedProject.project_name}'`);
              return false;
            }
          }else{
            this.updateTaskFields("assignee_id", this.filteredData.users);
          }  
  
        }else if(filterTypeValue == "reporter"){
          this.updateTaskFields("created_by_id", this.filteredData.reporter);
        }else if(filterTypeValue == "start_date"){
          this.updateTaskFields("start_date", this.filteredData.start_date);
        }else if(filterTypeValue == "due_date"){
          this.updateTaskFields("due_date", this.filteredData.due_date);
        }else if(filterTypeValue == "project"){
          this.updateTaskFields("project_id", this.selectedProject._id);
        }else if(filterTypeValue == "cc_users"){
          let ccUsersList = [];
          if (this.filteredData.cc_users != ""){
            ccUsersList = this.filteredData.cc_users.replaceAll(" ", "").split(",")
            if(ccUsersList.length>0){
              for(let i = 0; i < ccUsersList.length ; i++){
                if (this.emailRegex.exec(ccUsersList[i]) == null) {
                  this.$toast.error("Please use valid CC mail Ids");
                  return false;
                }
              }
            }
          }
          this.updateTaskFields("cc_users", ccUsersList);
        }
      }  
    },

    attachedFilesList(attcahedFilesArray,alreadyAttachedFiles,doNotUpdateAttachment=false){ 
        this.attachedFilesArr = [];
        if(alreadyAttachedFiles != undefined && alreadyAttachedFiles.length){
            for(let j = 0; j< alreadyAttachedFiles.length; j++){
              if(alreadyAttachedFiles[j].file_uid)this.attachedFilesArr.push(alreadyAttachedFiles[j].file_uid);
            }
        }
        if(attcahedFilesArray != undefined && attcahedFilesArray.length){
            for(let i=0; i<attcahedFilesArray.length; i++){
              if(attcahedFilesArray[i].fileUID)this.attachedFilesArr.push(attcahedFilesArray[i].fileUID);
            }
        }
        if(doNotUpdateAttachment){
          return false;
        }else{
          this.$nextTick(()=>{  
            if(this.enableEditMode == true){
              this.updateTaskFields('attachments',this.attachedFilesArr)
            }
          }); 
        }
        
    },

    loadAllFieldValues(){
        // if(('comments' in this.indTaskInfo) && this.indTaskInfo.comments.length>0){
        //   this.activeIndex = "comments";
        //   this.$router.replace({
        //     name: this.$route.name,
        //     params:{
        //       tabType:"cm"
        //     }
        //   });  
        // }
        
        if (this.$route.params.tabType && ![undefined, null].includes(this.$route.params.tabType)){
          if(this.$route.params.tabType == "de"){
            this.activeIndex = "details";
          }else if(this.$route.params.tabType == "cm"){
            this.activeIndex = "comments";
          }else if(this.$route.params.tabType == "ht"){
            this.activeIndex = "history";
          }
        }

        this.defaultTaskType = this.indTaskInfo.task_type;
        this.reviewDetails = this.indTaskInfo;
        this.titleValue = this.indTaskInfo.title;
        this.description = this.indTaskInfo.description;
        this.previousDescription = this.indTaskInfo.description;
        this.attachedFiles = this.indTaskInfo.attachments_info;
          
        if(('project_id' in this.indTaskInfo) &&  ![undefined, null].includes(this.indTaskInfo.project_id)){
            let projectObj = {};
            projectObj["_id"] = this.indTaskInfo.project_id;
            let allProjectsList = JSON.parse(localStorage.getItem('pam_projects_list'));
            let projectDict = allProjectsList.find(op=>op._id == this.indTaskInfo.project_id)
              projectObj["project_name"] = projectDict.project_name;
              projectObj["short_code"]= projectDict.short_code;
    
            this.selectedProject = projectObj;
            if(Object.keys(this.selectedProject).length>0){
              let payload = {}, params = {project_id:this.selectedProject._id};
              payload.params = params;
              this.getProjectsUsersFromServer(payload).then((data) =>{
                this.selectedProjectUsersList = data["users"];
              }); 
              }
    
        }
      
        if(('cloned_id' in this.indTaskInfo) &&  ![undefined, null].includes(this.indTaskInfo.cloned_id)){
          this.showClone = true
        }

        if(('cloned_data' in this.indTaskInfo) &&  Object.keys(this.indTaskInfo.cloned_data).length){
          this.clonedData = this.indTaskInfo.cloned_data
        }

        if(('file_info' in this.indTaskInfo) && !['undefined', undefined,null].includes(this.indTaskInfo.file_info) &&  this.indTaskInfo.file_info.length>0){
          this.assetsInfo = this.indTaskInfo.file_info;
          if('file_uid' in this.indTaskInfo.file_info[0]){
            this.activeFileIndex = this.indTaskInfo.file_info[0].file_uid;
            this.selectedFileId = this.indTaskInfo.file_info[0].file_uid;
          }
        }
        this.commentsListFromServer = this.indTaskInfo.comments;
        this.renderSingleOrMultipleAttachments();
        
        if(this.$route.params.tabType == "cm"){
          if (this.$route.params.ticketReplycommentId && 
              this.$route.params.ticketReplycommentId != undefined && 
              this.$route.params.ticketReplycommentId !=null){

            //Just for load comment page -prev/next for page refresh --------------- 
            let payload = {}, pageObj={};
            let taskId = this.indTaskInfo._id, commentId = this.$route.params.ticketReplycommentId;
            payload["task_id"] = taskId;
            pageObj["comment_id"] = commentId;  
            payload.params = pageObj;
            payload.taskType = this.defaultTaskType;
            this.getServerCommentListData(payload).then((data) =>{
              let prevCommentList = data["comments"];
              this.commentsListFromServer = prevCommentList;

              if (this.$route.name != "ticket-reply-review-comments" ){
                let selectedComment = this.commentsListFromServer.filter((comment)=>comment._id==this.$route.params.ticketReplycommentId)
                  if (selectedComment.length !=0){
                    this.openReplyCommentThread(selectedComment[0]);
                  }
                  
                }
                this.openReplyThread(this.$route.params.ticketReplycommentId)
              }); 
              document.getElementById(this.$route.params.ticketReplycommentId).scrollIntoView(true);
            // end---------------------------------------------

          }else if (this.$route.params.boardReplycommentId && 
              this.$route.params.boardReplycommentId != undefined && 
              this.$route.params.boardReplycommentId !=null){
            //Just for load comment page -prev/next for page refresh --------------- 
            let payload = {}, pageObj={};
            let taskId = this.indTaskInfo._id, commentId = this.$route.params.boardReplycommentId;
            payload["task_id"] = taskId;
            pageObj["comment_id"] = commentId;  
            payload.params = pageObj;
            payload.taskType = this.defaultTaskType;
            this.getServerCommentListData(payload).then((data) =>{
              let prevCommentList = data["comments"];
              this.commentsListFromServer = prevCommentList;

              if (this.$route.name != "board-reply-comments" ){
                let selectedComment = this.commentsListFromServer.filter((comment)=>comment._id==this.$route.params.boardReplycommentId)
                  if (selectedComment.length !=0){
                    this.openReplyCommentThread(selectedComment[0]);
                  }
                  
                }
                this.openReplyThread(this.$route.params.boardReplycommentId)
              }); 
              document.getElementById(this.$route.params.boardReplycommentId).scrollIntoView(true);
            // end---------------------------------------------
          }else if (this.$route.params.issueReplycommentId && 
              this.$route.params.issueReplycommentId != undefined && 
              this.$route.params.issueReplycommentId !=null){

            //Just for load comment page -prev/next for page refresh --------------- 
            let payload = {}, pageObj={};
            let taskId = this.indTaskInfo._id, commentId = this.$route.params.issueReplycommentId;
            payload["task_id"] = taskId;
            pageObj["comment_id"] = commentId;  
            payload.params = pageObj;
            payload.taskType = this.defaultTaskType;
            this.getServerCommentListData(payload).then((data) =>{
              let prevCommentList = data["comments"];
              this.commentsListFromServer = prevCommentList;

              if (this.$route.name != "issue-reply-comments" ){
                let selectedComment = this.commentsListFromServer.filter((comment)=>comment._id==this.$route.params.issueReplycommentId)
                  if (selectedComment.length !=0){
                    this.openReplyCommentThread(selectedComment[0]);
                  }
                  
                }
                this.openReplyThread(this.$route.params.issueReplycommentId)
              }); 
              document.getElementById(this.$route.params.issueReplycommentId).scrollIntoView(true);
            // end---------------------------------------------
          }else if (this.$route.params.taskReplycommentId && 
              this.$route.params.taskReplycommentId != undefined && 
              this.$route.params.taskReplycommentId !=null){

            //Just for load comment page -prev/next for page refresh --------------- 
            let payload = {}, pageObj={};
            let taskId = this.indTaskInfo._id, commentId = this.$route.params.taskReplycommentId;
            payload["task_id"] = taskId;
            pageObj["comment_id"] = commentId;  
            payload.params = pageObj;
            payload.taskType = this.defaultTaskType;
            this.getServerCommentListData(payload).then((data) =>{
              let prevCommentList = data["comments"];
              this.commentsListFromServer = prevCommentList;

              if (this.$route.name != "task-reply-comments" ){
                let selectedComment = this.commentsListFromServer.filter((comment)=>comment._id==this.$route.params.taskReplycommentId)
                  if (selectedComment.length !=0){
                    this.openReplyCommentThread(selectedComment[0]);
                  }
                  
                }
                this.openReplyThread(this.$route.params.taskReplycommentId)
              }); 
              document.getElementById(this.$route.params.taskReplycommentId).scrollIntoView(true);
            // end---------------------------------------------
          }else{
            this.$nextTick(() => {
                if(this.$refs.mainCommentsWrapper){
                  let scrollHeight = this.$refs.mainCommentsWrapper.scrollHeight + 2;
                  this.$refs.mainCommentsWrapper.scrollTop = scrollHeight;
                }  
            });
          }  
        }  
    },

    checkIfFromPipeline(){
        if(this.$route.query && this.$route.query.fromPipeline && Object.keys(this.$route.query.fromPipeline).length > 0){
          return true;
        }
        return false;
    },

    addNewTaskData(){
      console.log("decription..................", this.description);
      console.log("title............................",this.taskTitle);
      console.log("filteredData...................", this.filteredData);
      console.log("commen.....................", this.mainComment);
      console.log("fileInfo........................", this.assetsInfo);
      console.log("attached file uid list................", this.attachedFilesArr);

      if(document.getElementsByClassName("upload-unInitialized") && document.getElementsByClassName("upload-unInitialized").length){
          if (confirm(`Upload not initialized, do you want to continue?`)) {
              //do nothing
              this.abortUpload = true;
          }else{
              return false;
          }
      }
      if(document.getElementsByClassName("upload-in-progress") && document.getElementsByClassName("upload-in-progress").length){
          if (confirm(`Upload is still in progress, wait until it's complete.`)) {
              return false;
          }else{
              this.abortUpload = true;
              //do nothing
          }
      }

      if(this.taskTitle == ""){
        this.$toast.error("Empty " +this.defaultTaskType+" Title");
        return false;
      }

      if((this.filteredData.users == undefined || this.filteredData.users.length == 0) && this.defaultTaskType != 'Ticket'){
        this.$toast.error("Please select Assignee");
        return false;
      }

      if(this.filteredData.status.length == 0){
        alert("Select status");
        return false;
      }

      // let filesUIDList = [];
      // // if(Object.keys(this.assetsInfo).length > 1){
      //   if(this.assetsInfo != undefined || this.assetsInfo != null){
      //       if((this.assetsInfo).file_uid == undefined){
      //           for(let key in this.assetsInfo){
      //               let fileUid = this.assetsInfo[key].file_uid;
      //               if(filesUIDList.indexOf(fileUid) == -1){
      //               filesUIDList.push(fileUid);
      //               }
      //           }
      //       }else{
      //           filesUIDList.push(this.assetsInfo.file_uid);
      //       } 
      //   }     

      let commentsList = [];
      let commentObj = {};
      // commentObj["status"] = "New";
      if( this.activeFileIndex != null &&  this.activeFileIndex != undefined){
        commentObj["file_uid"] = this.activeFileIndex;
      }
      let parentComment = {};
      parentComment["comment"] = this.mainComment;
      parentComment["user_id"] = this.getLoggedInUserId();
      commentObj["parent_comment"] = parentComment;
      commentsList.push(commentObj);

      let taskInfo = {};
      
      
      taskInfo["title"] = this.taskTitle;
    //   if(this.description == ""){
    //     this.$toast.error("Empty Description");
    //     return false;
    //   }
      taskInfo["description"] = this.description;
      taskInfo["priority"] = this.filteredData.priority;
      // taskInfo["status"] = this.filteredData.status;
      taskInfo["created_by_id"] = this.getLoggedInUserId();

      if(this.selectedLinkTypeList.length>0){
        let selectedLinksToBePost = [];
        for(let i=0; i<this.selectedLinkTypeList.length;i++){
          let linkPostObj = {};
          linkPostObj["link_id"] = this.selectedLinkTypeList[i].link_id;
          let taskTagList = [];
          if(this.selectedLinkTypeList[i].linked_info.length>0){
            for(let j=0; j<this.selectedLinkTypeList[i].linked_info.length;j++){

              taskTagList.push(this.selectedLinkTypeList[i].linked_info[j].task_tag);
            }
            linkPostObj["linked_info"] = taskTagList;
          }
          if(Object.keys(linkPostObj).length > 0){
            selectedLinksToBePost.push(linkPostObj);
          }
        }
        if(selectedLinksToBePost.length >0){
          taskInfo["link_type_info"] = selectedLinksToBePost;
        }
      }
      
      if(this.selectedProjectUsersList && this.selectedProjectUsersList.length>0 && this.defaultTaskType != 'Ticket'){
        let isUserFound = this.selectedProjectUsersList.find(op=>op.user_id == this.filteredData.users);
        if(isUserFound){
            taskInfo["assignee_id"] = this.filteredData.users;
        }else{
            this.$toast.error(`Selected Assignee is not a part of Project '" ${this.selectedProject.project_name}'`);
            return false;
        }
      }else{
        if(this.filteredData.users){
          taskInfo["assignee_id"] = this.filteredData.users;
        }  
      }  

      
      taskInfo["comment_threads"] = commentsList;
      // if(filesUIDList.length>0){
      //   taskInfo["file_uids"] = filesUIDList;
      // }  
      taskInfo["attachments"]  = this.attachedFilesArr;
      taskInfo["task_type"] = this.defaultTaskType;
      if(![undefined, null].includes(this.selectedProject)){
        taskInfo["project_id"] = this.selectedProject._id;
      }  
      taskInfo["start_date"]= this.filteredData.start_date;
      
      if(![null, undefined].includes(this.filteredData.cc_users)){
        let ccUsersList = [];
        if (this.filteredData.cc_users != ""){
          ccUsersList = this.filteredData.cc_users.replaceAll(" ", "").split(",");
          if(ccUsersList.length>0){
            let emailValidate = true;
            for(let i = 0; i < ccUsersList.length ; i++){
              if (this.emailRegex.exec(ccUsersList[i]) == null) {
                emailValidate = false;
                this.$toast.error("Please use valid CC mail Ids");
                // alert("Please use valid CC mail Ids");
                break;
              }
            }
            if(emailValidate == false){
              return false;
            }
          }
          taskInfo["cc_users"] = ccUsersList;
        }
      }
      taskInfo["due_date"]= this.filteredData.due_date;
      // taskInfo["sub_status"]="Not taken Up";;
      // taskInfo["pid"] = 0;
      console.log("this....................................aaaaaaaaaaaaaaaaaaa",this.$route)
      if(this.$route.query && this.$route.query.fromPipeline && Object.keys(this.$route.query.fromPipeline).length > 0){
        taskInfo['stage_id'] = this.$route.query.fromPipeline.stage_id
        taskInfo['entity_id'] = this.$route.query.fromPipeline.entity_id
        taskInfo['template_id'] = this.$route.query.fromPipeline.template_id
      }
      let SeqMetadata = this.$refs.sequenceMetadataModel.getSequenceMetadataMap(false);
      if(!SeqMetadata){
        console.log("Metadata: Mandatory fields were missed. Hence returning.")
        return false;
      }
      if(this.viewTask == undefined || !this.viewTask){
        taskInfo["custom_metadata"] = SeqMetadata;
      }

      if(this.defaultTaskType == "Ticket"){
        this.addNewTicket(taskInfo).then((data) => {
          this.enableEditMode = false;
          // this.$emit("close")
          if (Utils.isAcceptedStatusCode(data.status_code)) {
            if(data.message) this.$toast.success(data.message);
            this.newUserData = data;
            this.$emit("changeSelectedComponent", "show-user");
            this.closeModel();
          } else {
            if(data.message) this.$toast.error(data.message);  
          }
        });
      }else{
        this.addNewTask(taskInfo).then((data) => {
          this.enableEditMode = false;
          if (Utils.isAcceptedStatusCode(data.status_code)) {
            if(data.message) this.$toast.success(data.message);
            this.newUserData = data;
            this.$emit("changeSelectedComponent", "show-user");
            // this.$emit("close")
          this.closeModel();
          } else {
            if(data.message){
               this.$toast.error(data.message);  
            }else if(data.errors){
               this.$toast.error(data.errors[0]);   
            }     
          }
        });
      }  
    },

    renderSingleOrMultipleAttachments(){
        if(![undefined, null].includes(this.assetsInfo) && Object && !Object.hasOwnProperty.call(this.assetsInfo,'_id')){
            this.assetDetails = Object.values(this.assetsInfo)[0];
            this.assets =  Object.values(this.assetsInfo);
        }else{
            this.assetDetails = this.assetsInfo;
            this.assets = [this.assetsInfo];   
        }
    },
    formatedDate(date){
        return Utils.getDateFormat(date);
    },

    formatDateAndTime(date){
        return Utils.getDateAndTimeFormat(date);
    },


    updateTaskFields(field, value, requestingFordeletelink){
        let payload={};
        // payload = this.proxyConfig;
        // payload.params = commentPostdata;
        let selectedTaskId = this.indTaskInfo._id;
        payload.taskId = selectedTaskId;
        let reviewObj = {};
        reviewObj[field] = value;
        if(requestingFordeletelink){
          reviewObj["remove_links"] = true;
        }
        payload.params = reviewObj;
        payload.taskType = this.defaultTaskType;
        this.updateTaskData(payload).then((data) => {
            this.cancelSelectedReviewFields(field)
            if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                if(data.message){
                  this.$toast.success(data.message);
                }else{
                  this.$toast.success("Successfully Updated")
                }  
                // this.$toast("Task is updated successfully");
            } else {
              if(data.message) this.$toast.error(data.message);
            }
        });
    },

    cancelSelectedReviewFields(keyName) {
        if(keyName == "title"){
          this.isTitleEditing = false;
          this.titleValue = this.reviewDetails.title;
        }else if(keyName == "description"){
          this.isDescriptionEditing = false;
          this.description = this.previousDescription;
        }
        // this.reviewDetails[keyName] = this.proxyCOnfigTemp1[keyName];
    },

    overWriteDescriptionValue(){
      // if(isAllowToUpdate == true){
        this.description =  this.updateDescriptionOnRelaodText;
        this.previousDescription = this.updateDescriptionOnRelaodText;
        this.updateDescriptionOnRelaodText = "";
        this.isDescriptionEditing = false;
      // }
    },

    detectBackspace(){
      let lastWord = this.description.split(" ");
      let mentionCharacterCheck = lastWord[lastWord.length - 1].startsWith('@');
      if(mentionCharacterCheck){
          this.descriptionKeypressedForMention = lastWord[lastWord.length - 1];
      }else{
          this.descriptionKeypressedForMention = '';
          this.showMentions = false;
      }
    },

    checkForMentions(e){
        if(this.isClientUser() == false){
          let temp = /[ `!#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
          if(temp.test(e.key) || e.code == 'Space'){
              this.showMentions = false;
              this.descriptionKeypressedForMention = '';
              return;
          }
          
          if(e.key == '@'){
              if(this.descriptionKeypressedForMention.startsWith('@')){
                  this.showMentions = false;
              }else{
                  this.showMentions = true;
                  this.descriptionKeypressedForMention = e.key;
              }
                  this.showMentions = true;
          }
          if(this.descriptionKeypressedForMention.startsWith('@')){
              if(e.key != '@'){
                  this.descriptionKeypressedForMention = this.descriptionKeypressedForMention.concat(e.key);
              }
          }else{
              this.descriptionKeypressedForMention = '';
              this.showMentions = false;
          }
        }else{
          this.showMentions = false;
        } 
    },

    selectElementsThroughKeys: function(event) {
        switch (event.keyCode) {
            case 38:
            if (this.focus === null) {
                this.focus = 0;
            } else if (this.focus > 0) {
                this.focus--;
                event.preventDefault();
            }
            this.fixScrolling();
            break;
            case 40:
            if (this.focus === null) {
                this.focus = 0;
            } else if (this.focus < this.selectedProjectUsersList.length - 1) {
                this.focus++;
                event.preventDefault();
            }
            this.fixScrolling();
            break;
            case 13:
                if(this.showMentions){
                    this.stop = true;
                    this.selectUserToBeMentioned(this.filteredDropdown[this.focus]);
                    event.preventDefault();
                }
            break;
        }
    },

    // usersListFn() {
    //     // this.getAllUsersFromServer().then((data) => {
    //     //     this.usersList = data['users'];
    //     // }) 
    //     let projectSelected = null;
    //     if(![undefined, null].includes(localStorage.getItem('selected_project_obj'))){
    //         projectSelected = JSON.parse(localStorage.getItem('selected_project_obj'))
    //     }else{
    //         projectSelected = this.allProjectsList[0];
    //     }   
    //     let payload = {}, params = {project_id:projectSelected._id};
    //     payload.params = params;
    //     this.getProjectsUsersFromServer(payload).then((data) =>{
    //       this.selectedProjectUsersForMentionAndAssignee = data["users"];
    //     });             
    // },

    style(name){
        let style = {
            'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
            'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style;
    },

    selectUserToBeMentioned(userData){
        let curPos = 0;
        if(this.$refs["descriptionArea"]){
            curPos = this.$refs["descriptionArea"].selectionStart;
        }else if(this.$refs["replyMessageArea"]){
            curPos = this.$refs["replyMessageArea"].selectionStart;
        }
        let text_to_replace = userData.username + " ";
        if(this.descriptionKeypressedForMention.length == 1 && this.descriptionKeypressedForMention == '@'){
            this.description = this.description.slice(0, curPos) + text_to_replace + this.description.slice(curPos);
        }else{
            this.description = this.description.slice(0, curPos - this.descriptionKeypressedForMention.length) + '@'+text_to_replace + this.description.slice(curPos);
        }
        this.descriptionKeypressedForMention = '';
        this.showMentions = false;
        if(this.$refs["descriptionArea"]){
            this.$refs.descriptionArea.focus();
        }
    },

    fixScrolling(){
        const liH = this.$refs.test[this.focus].clientHeight;
        this.$refs.scrollContainer.scrollTop = liH * this.focus;
    },

    urlify(text) {
      if(text != undefined && text != null && text != ""){
        text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g,'&gt;')
        var mentionsRegex = /\B@[a-z0-9_-]+/gi;
        let that = this;
        text = text.replace(mentionsRegex,function(mention){
            let temp = mention.substr(1);
            if(temp == that.getLoggedInUser()){
                return '<span style="border-radius: 15px;padding: 3px 7px;background: #007373c9;color: #eee;">' + mention + '</span>';
            }else{
                return '<span style="border-radius: 15px;background: transparent;color: #2cbdbd;">' + mention + '</span>';
            }
        })
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="_blank" style="overflow-wrap: anywhere;color:#1d9bd1">' + url + '</a>';
        });
      }else{
        return ""
      } 
    },

    isClientUser(){
      if(this.getLoggedInUserType() == 'Client'){
        return true;
      }else{
        return false;
      }
    },

    cloneTicketAsIssue(){
        let payload={};
        payload.ticketId = this.indTaskInfo._id;
        this.cloneTicket(payload).then((data) => {
            if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                if(data.message) this.$toast.success(data.message);
            } else {
              if(data.errors) this.$toast.error(data.errors);
            }
        });

    },

    linkTaskOrIssue(){
      this.allowToAddNewLink = true;
      this.showLinkedTasks = true;
    },

    getSelectedTaskIds(){
      let taskIdsStr = "";
      for(var i=0; i< this.selectedLinkTasksIssuesList.length;i++){
        if(i==0){
          taskIdsStr += this.selectedLinkTasksIssuesList[i].task_tag;
        }else{
          taskIdsStr += " , " +this.selectedLinkTasksIssuesList[i].task_tag;
        }
      }  
      return taskIdsStr;
    },

    addNewLinkTaskIssue(){
      let linkInfoObj = {};
      if(this.selectedLInkType){
        linkInfoObj["link_id"] =  this.selectedLInkType.link_id;
      }
      if(this.selectedLinkTasksIssuesList.length >0){
        linkInfoObj["linked_info"] = this.selectedLinkTasksIssuesList;
      }

      let linkIndex = this.selectedLinkTypeList.findIndex((obj)=>obj.link_id == this.selectedLInkType.link_id); 
      if(linkIndex < 0){
        this.selectedLinkTypeList.push(linkInfoObj);
      }else if(linkIndex >= 0){
        if(this.selectedLinkTasksIssuesList.length > 0){
          for(let i=0; i<this.selectedLinkTasksIssuesList.length;i++){
            let tagIdIndex = this.selectedLinkTypeList[linkIndex].linked_info.findIndex((obj)=>obj.task_tag == this.selectedLinkTasksIssuesList[i].task_tag);
            if(tagIdIndex < 0){
              this.selectedLinkTypeList[linkIndex].linked_info.push(this.selectedLinkTasksIssuesList[i])
            }
          }
          // this.selectedLinkTypeList[linkIndex].linked_info = this.selectedLinkTypeList[linkIndex].linked_info.concat(this.selectedLinkTasksIssuesList)
        }
      }

      this.allowToAddNewLink = false;
      this.selectedLinkTasksIssuesList = [];
      this.selectedLInkType = this.inWardOutWardLists[0];

      if(this.enableEditMode){
        if(this.selectedLinkTypeList.length>0){
          let selectedLinksToBePost = [];
          for(let i=0; i<this.selectedLinkTypeList.length;i++){
            let linkPostObj = {};
            linkPostObj["link_id"] = this.selectedLinkTypeList[i].link_id;
            let taskTagList = [];
            if(this.selectedLinkTypeList[i].linked_info.length>0){
              for(let j=0; j<this.selectedLinkTypeList[i].linked_info.length;j++){

                taskTagList.push(this.selectedLinkTypeList[i].linked_info[j].task_tag);
              }
              linkPostObj["linked_info"] = taskTagList;
            }
            if(Object.keys(linkPostObj).length > 0){
              selectedLinksToBePost.push(linkPostObj);
            }
          }
          if(selectedLinksToBePost.length >0){
            this.updateTaskFields('link_type_info',selectedLinksToBePost);
          }
        }
      }
    },

    deleteLinkedTaskOrIssue(linkId, linkedTaskOrIssueObj){
          let index = this.selectedLinkTypeList.findIndex((obj)=> obj.link_id == linkId);
          if(index > -1){

          
          let linkInfoIndex = this.selectedLinkTypeList[index].linked_info.findIndex((obj)=> obj.task_tag == linkedTaskOrIssueObj.task_tag);
            if(linkInfoIndex > -1){
              this.selectedLinkTypeList[index].linked_info.splice(linkInfoIndex, 1);

              if(this.selectedLinkTypeList[index].linked_info.length == 0){
                this.selectedLinkTypeList.splice(index,1);
              }
            }
            // this.selectedLinkTypeList = this.selectedLinkTypeList.splice(index, 1);
          }
        if(this.enableEditMode){
          // this.updateTaskFields('link_type_info',this.selectedLinkTypeList);
          let selectedLinksToBePost = [];
          if(this.selectedLinkTypeList.length>0){
            for(let i=0; i<this.selectedLinkTypeList.length;i++){
              let linkPostObj = {};
              linkPostObj["link_id"] = this.selectedLinkTypeList[i].link_id;
              let taskTagList = [];
              if(this.selectedLinkTypeList[i].linked_info.length>0){
                for(let j=0; j<this.selectedLinkTypeList[i].linked_info.length;j++){

                  taskTagList.push(this.selectedLinkTypeList[i].linked_info[j].task_tag);
                }
                linkPostObj["linked_info"] = taskTagList;
              }
              if(Object.keys(linkPostObj).length > 0){
                selectedLinksToBePost.push(linkPostObj);
              }
            }
          }
          this.updateTaskFields('link_type_info',selectedLinksToBePost, true);
        }  
    },

    cancelLinkTaskIssue(){
      this.allowToAddNewLink = false;
    },

    getLInkTypeName(linkTypeId){
      let linkObj = this.inWardOutWardLists.find((obj)=>obj.link_id == linkTypeId);
      return linkObj;
    },

    getLinkTypesList(){
        let payload = {};
        this.getLinkTypesFromServer(payload).then((data) =>{
            this.linkTypeDataList = data["link_types"];
            // this.totalPages = data["page_count"];
            // this.page = data["page"];
            // this.totalLinkTypes = data["total_link_types"];
            // this.linkTypesPerPage = data["link_types_per_page"];

            this.inWardOutWardLists = [];
            for(let i=0; i<data["link_types"].length;i++){
              let inwardObj = {}, outwardObj = {};
              inwardObj["link_id"] =  data["link_types"][i].inward_uid;
              inwardObj["label"] = data["link_types"][i].inward_desc;
              this.inWardOutWardLists.push(inwardObj);

              outwardObj["link_id"] =  data["link_types"][i].outward_uid;
              outwardObj["label"] = data["link_types"][i].outward_desc;
              this.inWardOutWardLists.push(outwardObj);
            }
            this.selectedLInkType = this.inWardOutWardLists[0];
        });
    },

    onlinktypeChange(option){
      this.selectedLInkType = option;
    },

    async getProjectIdData(text){
          let urlRegex = /(https?:\/\/[^\s]+)/g;
          let temp = '',link='', arr = [];
              text.replace(urlRegex, function(url) {
                  temp = url;
                  link = url;
                  if(!(arr.includes(temp))){
                      arr.push(temp)
                  }
              })
              // this.previewData = []; 
              let previewData = []; 
              for(let i = 0; i < arr.length; i++){
                  let checkUrl = arr[i].split("?");
                  let item = checkUrl[0].split("/");
                  let id = null;
                  if(item.includes("de") || item.includes("cm")){
                      if(item.indexOf("de") == item.length - 1 || item.indexOf("cm") == item.length - 1){
                          id = item[item.length-2]
                      }else{
                          id = item[item.length-3]
                      }
                  }else{
                      id = item[item.length-1];
                  }
                  if(id){
                      let payload = {};
                      payload["taskId"] = id;
                      if(item.indexOf('ticket').length > 0){
                          payload.taskType = "Ticket";
                      }


                    await this.getServerIndTaskData(payload).then((data) =>{
                          data['task']['url'] = link;
                          previewData.push(data["task"]);
                      });
                  }
              }

              // setTimeout(()=>{
                  return previewData[0];
              // },1000);
      },

    openPamBrowseOnClick(browser){
        this.browserType = "fusion";
        if(browser == 'fusion'){
            this.chatBrowseWorkspaceList = [Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS];
        }else if(browser == 'tickets'){
            this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TICKETS];
        }else if(browser == 'tasks'){
            this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TASKS];
        }else if(browser == 'issues'){
            this.chatBrowseWorkspaceList = [Constants.WORKSPACE_ISSUES];
        }
    },

    handleFilesBrowse(selectedFiles){
        if(this.chatBrowseWorkspaceList.filter(e =>[Constants.WORKSPACE_TICKETS,Constants.WORKSPACE_TASKS,Constants.WORKSPACE_ISSUES].includes(e)).length){
            for(let i= 0 ;i<selectedFiles.length;i++){
                let urlType = "";
                if(selectedFiles[i].task_type == 'Task'){
                    urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/tasks/";
                }else if(selectedFiles[i].task_type == "Issue"){
                    urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/issues/";
                }else if(selectedFiles[i].task_type == "Ticket"){
                    urlType = "/explorer/ticket/";
                }
                let appendUrl = window.location.protocol + '//' + window.location.host + urlType + selectedFiles[i].task_tag;
                // let curPos = 0;
                // if(this.$refs["commentArea"]){
                //     curPos = this.$refs["commentArea"].selectionStart;
                // }else{
                //     curPos = this.$refs["replyMessageArea"].selectionStart;
                // }
                // this.commentText = this.commentText.slice(0, curPos) + " " +appendUrl + " " + this.commentText.slice(curPos);
                // if(this.$refs["commentArea"]){
                //     this.$refs.commentArea.focus();
                // }else if(this.$refs["replyMessageArea"]){
                //     this.$refs.replyMessageArea.focus();
                // }
                let tagObj = {};
                tagObj["task_tag"] = selectedFiles[i].task_tag;
                tagObj["preview_url"] = appendUrl;
                let index = this.selectedLinkTasksIssuesList.findIndex((obj)=>obj.task_tag == selectedFiles[i].task_tag)
                if(index < 0){
                  this.selectedLinkTasksIssuesList.push(tagObj);
                }
            }
        }else{
            this.attachedFiles = selectedFiles;
            this.openAttachments = true;
        }
            this.browserType = '';
    },

    closeModal(){
        this.attachedFiles = [];
        this.browserType = '';
        // this.openFileBrowse = false;
    },

    handleReviewCommentsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message && this.reviewDetails._id == notification.message.task_id){
        // this.$toast.info("New Comment is added") ;
        if(notification.message.pid == "0"){
            let comment_info = notification.message
            let commentObj = this.commentsListFromServer.filter((comment)=>comment._id == comment_info._id);
            if (commentObj.length !=0){
                commentObj = commentObj[0]
                commentObj.status = comment_info.status;
                commentObj.comment = comment_info.comment;
                // Object.assign(commentObj, comment_info); --- this line if for to update whole dictionary of comment
            }else{
              this.$nextTick(() =>{
                this.commentsListFromServer.push(notification.message);
                this.$nextTick(() =>{
                    if(this.$refs.mainCommentsWrapper){
                      let scrollHeight = this.$refs.mainCommentsWrapper.scrollHeight + 2;
                      this.$refs.mainCommentsWrapper.scrollTop = scrollHeight;
                    }  
                  }); 
              });  
            }
            //  this.commentsListFromServer.push(notification.message);

            if(notification.message._id == this.selectedCommentThreadId){
              let comment_info = notification.message
              let replyCommentObj = this.repliedCommetslist.filter((comment)=>comment._id == comment_info._id);
              if (replyCommentObj.length !=0){
                replyCommentObj = replyCommentObj[0]
                replyCommentObj.status = comment_info.status;
                replyCommentObj.comment = comment_info.comment;
              }
            }

        }else{
          if(notification.message.pid == this.selectedCommentThreadId){
            // this.$toast.info("New Reply is added") ;
            let comment_info = notification.message
            let replyCommentObj = this.repliedCommetslist.filter((comment)=>comment._id == comment_info._id);
            if (replyCommentObj.length !=0){
                replyCommentObj = replyCommentObj[0]
                replyCommentObj.status = comment_info.status;
                replyCommentObj.comment = comment_info.comment;
                // Object.assign(commentObj, comment_info); --- this line if for to update whole dictionary of comment
            }else{
              this.repliedCommetslist.push(notification.message); 
              this.$nextTick(() => {
                if(this.$refs.replyCommentWrapper){
                    this.$refs.replyCommentWrapper.scrollTop = this.$refs.replyCommentWrapper.scrollHeight - 100;
                }
              });
            }

            document.getElementById(notification.message.pid).scrollIntoView(true);
            let replycontainer = this.$el.querySelector("#reply_comment_wrapper");
            this.$nextTick(()=>{ 
              replycontainer.scrollTop = replycontainer.scrollHeight + 30;  
            });
          }  
        }
      }
    },

    handleReviewUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let review_info = notification.message.review
        // let updatedReviewObj = this.reviewData.filter((reviewObj)=>reviewObj._id == review_info._id);
        if (review_info._id == this.reviewDetails._id){
          // this.$toast.info("'"+ review_info.review_tag +"' is Updated");
            // updatedReviewObj = updatedReviewObj[0]
            Object.assign(this.reviewDetails, review_info); //--- this line if for to update whole dictionary of comment
            this.description = review_info.description;
        }
    },

    handleCommentDeleteNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let commentInfo = notification.message;
        if( notification.message.modified_by_userId != this.getLoggedInUserId()){  
          this.$toast.info("Comment Deleted");
        }  
        if(notification.message.pid == "0"){
          this.commentsListFromServer = this.commentsListFromServer.filter((commentObj)=>commentObj._id != commentInfo._id);
          for(let i=0; i<this.repliedCommetslist.length;i++){
            if(this.repliedCommetslist[i].pid == "0" && this.repliedCommetslist[i]._id == commentInfo._id){
              this.repliedCommetslist = [];
              this.closeReplyThread();
            }
          }
        }else{
          this.repliedCommetslist = this.repliedCommetslist.filter((commentObj)=>commentObj._id != commentInfo._id);
          // for(let i=0; i<this.repliedCommetslist.length;i++){
          //   if(this.repliedCommetslist[i].pid == 0 && this.repliedCommetslist[i]._id == commentInfo._id){
          //     this.repliedCommetslist = [];
          //     this.closeReplyThread();
          //   }
          // }
        }    
    },

     handleTasksNotificationInDetailsWindow(notification){
       notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
              let task_info = notification.message;
              if (notification.message_type == "TASK_MODIFIED"){
                  if(this.reviewDetails._id == task_info._id){

                    // Object.assign(this.reviewDetails, task_info.task); //--- this line if for to update whole dictionary of comment
                        if((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser()){
                          if(Object.keys(task_info).includes("title")){
                              this.$set(this.reviewDetails, "title", task_info.title)
                          }
                          if(Object.keys(task_info).includes("description")){
                            this.$set(this.reviewDetails, "description", task_info.description);
                            this.description = task_info.description;
                              let textAreaEle = document.querySelector(".taskDescriptionField");
                              if(document.activeElement != textAreaEle){
                                this.description =  task_info.description;
                                this.previousDescription = task_info.description;
                              }else{
                                if(this.previousDescription != task_info.description){
                                  this.isDescriptionUpdated = true;
                                  this.updateDescriptionOnRelaodText =  task_info.description;
                                } else{
                                  this.description =  task_info.description;
                                  this.previousDescription = task_info.description;
                                }
                                
                              }
                          }
                        }  
                        

                        if(Object.keys(task_info).includes("description") && ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "description", task_info.description)
                        }

                        if(Object.keys(task_info).includes("priority") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "priority", task_info.priority)
                        }

                        if(Object.keys(task_info).includes("status")){
                            this.$set(this.reviewDetails, "status", task_info.status)
                        }

                        if(Object.keys(task_info).includes("modified_datetime") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "modified_datetime", task_info.modified_datetime)
                        }

                        if(Object.keys(task_info).includes("assignee_name") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "assignee_name", task_info.assignee_name)
                            this.$set(this.reviewDetails, "assignee_id", task_info.assignee_id)
                        }

                        if(Object.keys(task_info).includes("assignee_profile_image") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "assignee_profile_image", task_info.assignee_profile_image)
                        }

                        if(Object.keys(task_info).includes("short_code") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "short_code", task_info.short_code)
                        }

                        if(Object.keys(task_info).includes("task_type") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "task_type", task_info.task_type)
                            this.defaultTaskType = task_info.task_type;
                        }

                        if(Object.keys(task_info).includes("attachments") && Object.keys(task_info).includes("attachments_info") &&  ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                            this.$set(this.reviewDetails, "attachments", task_info.attachments)
                            this.$set(this.reviewDetails, "attachments_info", task_info.attachments_info);
                            this.showAttachments = true;
                            if(task_info.modified_by_userId != this.getLoggedInUserId()){
                              this.attachedFiles = [];
                              this.attachedFiles = task_info.attachments_info;
                            }
                        }

                        if(Object.keys(task_info).includes("custom_metadata")){
                            this.$set(this.reviewDetails, "custom_metadata", task_info.custom_metadata)
                        }
                  }  
              }   
          }
      },

    handleReplyCountUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
       let replyCountInfo = notification.message;
          let commentObj = this.commentsListFromServer.filter((comment)=>comment._id == replyCountInfo._id);

           if (commentObj.length !=0){
              commentObj = commentObj[0]
              commentObj["reply_count"] = replyCountInfo.reply_count;
              commentObj["replied_user_ids"] = replyCountInfo.replied_user_ids;
              commentObj["replied_user_names"] = replyCountInfo.replied_user_names;
              commentObj["replied_profile_images"] = replyCountInfo.replied_profile_images;
            }
      },

    handleTicketCloneNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let clonedTicketInfo = notification.message;
      if(this.reviewDetails._id == clonedTicketInfo.task._id){
        this.$set(this.reviewDetails, "link_type_info", clonedTicketInfo.task.link_type_info);
        this.selectedLinkTypeList = clonedTicketInfo.task.link_type_info;
      }
    },

    registerforWebsocketNotifications(){
        //comments-----------------
        this.addWSEventListener({
            eventname:["TASK_COMMENT_UPSERTED"],
            callback:this.handleReviewCommentsNotification,
            parent: "newTasksIssues"});

        this.addWSEventListener({
            eventname:["REVIEW_UPDATED"],
            callback:this.handleReviewUpdateNotification,
            parent: "newTasksIssues"});
          
        this.addWSEventListener({
            eventname:["TASK_COMMENT_DELETED"],
            callback:this.handleCommentDeleteNotification,
            parent: "newTasksIssues"}); 

        //tasks------------------
        // this.addWSEventListener({
        //   eventname:["TASK_CREATED"],
        //   callback:this.handleTasksNotificationInDetailsWindow,
        //   parent: "reviewdisplay"});

        this.addWSEventListener({
          eventname:["TASK_MODIFIED"],
          callback:this.handleTasksNotificationInDetailsWindow,
          parent: "newTasksIssues"});

        this.addWSEventListener({
          eventname:["TASK_REPLY_COUNT_CHANGED"],
          callback:this.handleReplyCountUpdateNotification,
          parent: "newTasksIssues"});
        
        // this.addWSEventListener({
        //   eventname:["TASK_DELETED"],
        //   callback:this.handleTasksNotificationInDetailsWindow,
        //   parent: "reviewdisplay"})

         this.addWSEventListener({
          eventname:["TICKET_CLONED"],
          callback:this.handleTicketCloneNotification,
          parent: "newTasksIssues"})

        
      },

      unRegisterforWebsocketNotifications(){
        //comments-----------------
        this.removeWSEventListener({
            eventname:["TASK_COMMENT_UPSERTED"],
            callback:this.handleReviewCommentsNotification,
            parent: "newTasksIssues"});

        this.removeWSEventListener({
            eventname:["REVIEW_UPDATED"],
            callback:this.handleReviewUpdateNotification,
            parent: "newTasksIssues"});
          
        this.removeWSEventListener({
            eventname:["TASK_COMMENT_DELETED"],
            callback:this.handleCommentDeleteNotification,
            parent: "newTasksIssues"}); 

        //tasks------------------
        // this.removeWSEventListener({
        //   eventname:["TASK_CREATED"],
        //   callback:this.handleTasksNotificationInDetailsWindow,
        //   parent: "reviewdisplay"});

        this.removeWSEventListener({
          eventname:["TASK_MODIFIED"],
          callback:this.handleTasksNotificationInDetailsWindow,
          parent: "newTasksIssues"});
        
        this.removeWSEventListener({
          eventname:["TASK_REPLY_COUNT_CHANGED"],
          callback:this.handleReplyCountUpdateNotification,
          parent: "newTasksIssues"});
        
        // this.removeWSEventListener({
        //   eventname:["TASK_DELETED"],
        //   callback:this.handleTasksNotificationInDetailsWindow,
        //   parent: "reviewdisplay"})

        this.removeWSEventListener({
          eventname:["TICKET_CLONED"],
          callback:this.handleTicketCloneNotification,
          parent: "newTasksIssues"})

      },

    ...mapActions("files", ["getFileInfoFromServer"]),
    ...mapActions("assets", ["getAssetInfoFromServer"]),
    ...mapActions("users", ["getAllUsersFromServer"]),
    ...mapActions("PAM", ["addNewTask", "addNewTicket", "getServerProjectsData", "updateTaskData","getServerTaskCommetRepliesData", "addNewParentCommentForTask","deleteCommentFromTask", "getServerIndTaskData", "getServerCommentListData","cloneTicket", "getProjectsUsersFromServer","getLinkTypesFromServer", "getHistoryFromServer"]),
    ...mapActions("reviewDataTemp", ["addNewReview", "addNewParentComment", "addNewReplyComment", "updateReviewData", "updateCommentData", "deleteCommentFromReview"]),
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserType"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  computed:{
    getWorkspacesList(){
        return this.chatBrowseWorkspaceList;
    },
    selectedAssetInfo(){
      return {componentDetailsFromParent:this.indTaskInfo}
    },
    attachmentData(){
      return {selectedFilesFromAttachBrowse:this.selectedFilesFromAttachments}
    },
    showFilterOnTickets(){
      return this.enableEditMode?Object.keys(this.indTaskInfo)!=0:true
    },
    filteredDropdown() {
        let assignedUsersList = [];
            assignedUsersList = this.selectedProjectUsersList;
        if(this.descriptionKeypressedForMention.substr(1) != null){
            if (!assignedUsersList.length) {
                return [];
            }
                return assignedUsersList.filter((item) => {
                const username = item.username.toLowerCase();
                const searchTerm = this.descriptionKeypressedForMention.substr(1).toLowerCase();
                return username.includes(searchTerm);
            });
        }else{
            return assignedUsersList;
        }
    },
    ...mapGetters("users",["getLoggedInUserPrivilege"])
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  },
  
  created(){   
    // this.enableEditMode = true;  
    Object.assign(this.parentRoute, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    if('editMode' in  this.$route.query){
      this.enableEditMode = Boolean(this.$route.query.editMode);
    }else if('taskId' in this.$route.params && this.$route.params.taskId){
      this.enableEditMode = true;
    }

    if('taskContext' in this.$route.query){
      this.taskContext = this.$route.query.taskContext;
    }
    
    if(![undefined, null].includes(this.taskContext)){   //order 1
        this.defaultTaskType = this.taskContext;
    }

    if(this.$route.name == "issues-projects" && this.taskContext != "Ticket"){ //order 2
      this.defaultTaskType = "Issue";
    }

    if(this.isTicket == true){ //order 3
      this.defaultTaskType = "Ticket"
    }

    if(![undefined, null].includes(this.taskDataFromChat) && Object.keys(this.taskDataFromChat).length>0){
      if(![undefined, null].includes(this.taskDataFromChat.message) && this.taskDataFromChat.message != ""){
        this.description = this.taskDataFromChat.message;
      }

      if(this.taskDataFromChat.attachments_info.length >0){
        this.attachedFiles = this.taskDataFromChat.attachments_info;
      }
    }
   
    this.assetsInfo = this.fileInfo;
    // this.getServerProjectsData().then((data) =>{
    if(![undefined, null].includes(localStorage.getItem('pam_projects_list'))){    
        this.allProjectsList = JSON.parse(localStorage.getItem('pam_projects_list'));
        this.$nextTick(()=>{  
          if(this.defaultTaskType != "Ticket" ){
              if(![undefined, null].includes(localStorage.getItem('selected_project_obj'))){
                  let selectedProjestObj = JSON.parse(localStorage.getItem('selected_project_obj'));
                  let isLoggedInUserExistsInProject = false;
                  if(selectedProjestObj.project_users && selectedProjestObj.project_users.length>0){
                    let userIndex = selectedProjestObj.project_users.findIndex((obj) => obj.user_id == this.getLoggedInUserId());
                    if(userIndex > -1){
                      isLoggedInUserExistsInProject = true;
                    }
                  }
                  if(isLoggedInUserExistsInProject){
                    this.selectedProject = JSON.parse(localStorage.getItem('selected_project_obj'))
                  }else{
                    this.selectedProject = null;
                  }  
              }else{
                  let isLoggedInUserExistsInProject = false;
                  if(this.allProjectsList[0].project_users && this.allProjectsList[0].project_users.length>0){
                    let userIndex = this.allProjectsList[0].project_users.findIndex((obj) => obj.user_id == this.getLoggedInUserId());
                    if(userIndex > -1){
                      isLoggedInUserExistsInProject = true;
                    }
                  }
                  if(isLoggedInUserExistsInProject){
                    this.selectedProject = this.allProjectsList[0];
                  }else{
                    this.selectedProject = null;
                  }
              }   
              let payload = {}, params = {project_id:this.selectedProject._id};
              payload.params = params;
              this.getProjectsUsersFromServer(payload).then((data) =>{
                this.selectedProjectUsersList = data["users"];
              }); 
          }else{
              this.selectedProject = [];
          }
        })  
        // this.requestingQueryParameters["project_id"] = this.selectedProject;
        // this.sendFilteredparametrs();
    }  

    if(this.enableEditMode == true){
        // this.taskId = "FA-36";

        this.taskId = this.taskId?this.taskId:this.$route.params.taskId
        let payload = {};
        payload.taskType = this.defaultTaskType;
        payload.taskId = this.taskId;
        this.getServerIndTaskData(payload).then((data) =>{
            let taskItem = data["task"];
            this.fileInfo = taskItem.file_info;
            this.taskInfo = taskItem;
            this.assetsInfo = this.fileInfo;
            this.getFilteredData();
            this.indTaskInfo = this.taskInfo;
            this.loadAllFieldValues();

            if('link_type_info' in data["task"] && data["task"].link_type_info.length>0){
              this.selectedLinkTypeList = data["task"].link_type_info;
            }
             
            if(this.$route.params.tabType == "ht"){
              this.getHistory();
              return;
            }
            
            if(this.$route.params.tabType == "de" || this.$route.params.tabType == "cm"){
              return;
            }
    
            if(this.$route.params && this.$route.params.tabType && this.$route.params.tabType != ""){
                let tabsMapper = {"cm":"comments","de":"details"};
                this.activeIndex = tabsMapper[this.$route.params.tabType];
                this.$router.replace({
                  name:"tasks-window",
                  params:Object.assign(this.$route.params,{tabType:this.$route.params.tabType}),
                  query:this.$route.query
                });
                return;
            }
            
            if(('comments' in this.indTaskInfo) && this.indTaskInfo.comments.length>0){
              this.activeIndex = "comments";
              this.$router.replace({
                // name: this.$router.name,
                name:"tasks-window",
                params:Object.assign(this.$route.params,{tabType:"cm"}),
                query:this.$route.query
              });
              
            }else{
              this.activeIndex = "details";
              this.$router.replace({
                // name: this.$router.name,
                name:"tasks-window",
                params:Object.assign(this.$route.params,{tabType:"de"}),
                query:this.$route.query
              });
            }

            
            // this.loadAllFieldValues();
        })
    }else{
        this.renderSingleOrMultipleAttachments();
    }

    // this.$nextTick(() => {
    //   this.usersListFn();
    // });  

    this.registerforWebsocketNotifications();
    if(!this.isClientUser()){
      this.getLinkTypesList();
    }  
        // this.$nextTick(() => {
        //     if(this.$refs.mainCommentsWrapper){
        //     let scrollHeight = this.$refs.mainCommentsWrapper.scrollHeight + 2;
        //     this.$refs.mainCommentsWrapper.scrollTop = scrollHeight;
        //     }  
        // });
    // });
  },

  watch: {
        // 'selectedProject': function (val) {
        //     if (val || val == "") {
        //         this.$nextTick(() => {
        //             this.selectedProject = val;
        //             // this.constructTasksTabel(false)
        //         })
        //     }
        // }

        "$route.fullPath" : function(newVal, oldVal){
          if (newVal!=oldVal){
            if (this.$route.name == "ticket-reply-review-comments" && ![undefined, null].includes(this.$route.params.ticketReplycommentId)){
              // this.activeIndex = "comments";
              this.openReplyThread(this.$route.params.ticketReplycommentId)
            }else if(this.$route.name == "board-reply-comments" && ![undefined, null].includes(this.$route.params.boardReplycommentId)){
              // this.activeIndex = "comments";
              this.openReplyThread(this.$route.params.boardReplycommentId)
            }else if(this.$route.name == "issue-reply-comments" && ![undefined, null].includes(this.$route.params.issueReplycommentId)){
              // this.activeIndex = "comments";
              this.openReplyThread(this.$route.params.issueReplycommentId)
            }else if(this.$route.name == "task-reply-comments" && ![undefined, null].includes(this.$route.params.taskReplycommentId)){
              // this.activeIndex = "comments";
              this.openReplyThread(this.$route.params.taskReplycommentId)
            }else{
              this.closeReplyThread();
            }
            
            if(this.$route.params.tabType == "de"){
              this.activeIndex = "details";  
            }else if(this.$route.params.tabType == "cm"){
              this.activeIndex = "comments";
            }else if(this.$route.params.tabType == "ht"){
              this.activeIndex = "history";
            }else{
              this.closeModel();
            }
          }
        },
    },

  mounted(){
    if(this.enableEditMode != true || this.enableEditMode == undefined){
      document.getElementById("task_title_field").focus();
    }
    this.$nextTick(() => {
      if(this.$refs["comment-textarea"].$el){
        this.resizeObservor = new ResizeObserver(() =>{
            // this.resizeObservor.disconnect();
            this.handleResize();
        });
        this.resizeObservor.observe(this.$refs["comment-textarea"].$el,{
              childList: true,
              subtree: true,
        });
      }
    });
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;

.icon-background-on-hover:hover{
  background: #d1d2d31a;
  border-radius: 4px;
}

.icon-background-on-hover{
  padding: 6px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
}

.close-or-min-panel{
    height: 38px;
    width:100%;
    border-bottom: $secondary-border-color;
    background: $secondary-background-color;
    text-align: end;
    // padding: 12px;
    padding-inline-start:0px;
    display: flex;
    svg{
        margin-inline-end:0px !important;
        top:-3px;
    }
}


.comm-lable-styles{
    font-size: 14px;

}

.descriptionSaveUnsaveBtns{
  position: relative;
  svg{
    color: $text-color;
    border: $border-color;
    background: $primary-background;
    margin-inline-end: 2px;
  }
}

.attachment-wrapper{
    padding: 10px 15px;
    width: 100%;
    display: inline-block;

    .comm-action-buttons-styles-on-tasks{
        width: 14%;
        display: flex;
        height: 38px;
        align-items: center;
        justify-content: center;
        background: $primary-background;
        border:$border-color;
        border-radius: 5px;
        margin-inline-end:5px;
        float: inline-start;
        position: relative;
    }
}    

.taskTitleSaveUnsaveBtns{
  position: relative;
  top: 8px;
  svg{
   color: $text-color;
    border: $border-color;
    background: $primary-background;
    margin-inline-end: 2px;
  }
}

svg:hover, svg.bi-x:hover {
    background: #222;
    // border-radius: 25px;
    fill:$text-color;
}

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

.nav-item{
    color: $dull-text-color !important;
}
.navbar-wrapper{
  height:40px
}
.contents-wrapper{
  height: calc(100% - 40px);
  overflow: auto;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size:15px;
}

.activeFile .file-main-div{
    background: $primary-background !important;
    color: $text-color!important;
    font-weight: 500;
    font-size:15px;
    border: 1px solid #007bff !important;
}
.top-nav-bar{
    background: $primary-background;
}

  .container{
      width: 100vw;
      list-style: none;
      padding: 0;
      margin: 0;
  }
  
  .modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-block;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  overflow: hidden;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-bottom: $secondary-border-color  !important;
    border-top: $secondary-border-color  !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      // color:$header-color;
      color:#dfdfdf;
      padding:3px;
    }
}

.modal-header .close {
    margin: -1rem -19px -0rem auto !important;
}

.modal-footer{
    float: inline-end;
    position: fixed;
    inset-inline-start: -10px;
    bottom: 0;
    width: 100%;
    display: inline-block;
    height: 50px;
    z-index:9;
}

.close-icon:hover{
  background: $bg-color-on-hover;
  border-radius: 20px;
}

.review-title-heading{ 
  margin:0px !important;
  width:80%;
  display: inline-block;
  height:50px;
  input{
    color:$text-color;
    height:100%;
    width:100%;
    padding-inline-start:10px !important;
  }
}  

.review-heading-input::placeholder {
  font-size:28px !important;
  font-weight: 100 !important;
  color: $secondary-text-color !important;
}


.comm-input-field-style{
    background: $primary-background!important;
    width: 70% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: 100%;
}

.replay-comments-main-wrapper{
  overflow: auto;
}

.addedMediaFilesDiv{
  position: absolute;
  top: 2px;
  inset-inline-end: 0px;
  width: 53%;
  background: $bg-color-on-hover;
  border: $border-color;
  border-radius: 5px;

  .individualFileEditIconDiv{
    float: inline-end;
    width: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg{
      width: 25px;
      height: 25px;
      padding:5px;
    }
  }
}

.markinMarkoutImageWrapperINReplyThread:hover{
  img{
    opacity: 0.2;
  }
  .annotate-btn{
    display: block !important;
  }
}

.mx-input{
  background-color: #1d1d1d!important;
}

.desc-text-cursor{
    color: $text-color;
    white-space: pre-wrap;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    cursor: auto;
    word-break: break-word;
}

.mentions-wrapper{
    position: relative;
    border: $border-color;
    background: $secondary-background-color;
    max-height: 200px;
    min-width:200px;
    overflow: auto;
    z-index: 9;
    border-radius: 5px;
    .mentions-option{
        text-align: start;
        padding: 5px;
        display:flex;
    }
    .mentions-option:hover{
        background: #333;
    }
}

.focusElement{
    background: #333;
}

.no-history-data{
    padding: 20px;
    width: 100%;
    display: inline-flex;
    text-align: center;
    height: 200px;
    align-items: center;
    justify-content: center;
    color: #989898;
}

/** v:deep overwrite */
::v-deep{

  .preview-wrapper{
    max-width:100% !important;
  }

   #mainProjectsDropdown{
     position: relative;
     top: 6px;
     .multiselect {
          box-sizing: content-box;
          display: block;
          position: relative;
          width: 100%;
          min-height: 40px;
          text-align: start;
          color: #35495e;
      }
      .multiselect__tags{
        display: flex;
        align-items: center;
        height:100%;
        padding-inline-start: 0px !important;
        background: transparent !important;
        padding: 0px 40px 0 8px!important;
        min-width:100px;
        border: none !important;
      }
      .multiselect__content-wrapper{
        width:auto !important;
        border: 1px solid rgb(66, 66, 66) !important;
        background-color: rgb(40, 40, 40) !important;
      }

      .multiselect__select{
        height:100%;
        // display: none !important;
      }

      .multiselect__select::before{
        border-color: #7f7f7f transparent transparent;
      }
     .multiselect__single{
       margin-bottom: 0px !important;
       font-size: 20px !important;
     }
   } 

   #mainProjectsDropdown:hover{
      .multiselect__select::before{
        border-color: #ddd transparent transparent;
      }
   }  

  .btn-outline-primary:hover{
    .media-edit-icon{
      background: #007bff !important;
      border-radius: 0px !important;
    }
  }

  .v-list-item--link:before{
    background-color:$primary-background;
  }
  .vjs_video_3-dimensions, .video-js{
        height:350px;
        width:100%;
   }
   .video-js{
        height:350px;
        width:100%;
    }
  .multiselect__content-wrapper{
    display:none;
  }
  .search-bar-comm-style{
      .multiselect__single{
          position: relative;
          inset-inline-start: 14px;
          color:$text-color;
      }
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__placeholder {
      padding-top: 0px !important;
      padding-inline-start:0px !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color!important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 14px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:100%;
    }
    .multiselect__option--selected{
       background: $bg-color-on-hover !important;
       color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: absolute;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
     .multiselect--above .multiselect__content-wrapper{
       background:$secondary-background-color !important;
    }
    .multiselect__tags {
        background: transparent !important;
        height: 38px;
        min-height: 38px ;
        margin: 3px 6px 3px 0px ;
        // border: none ;
        //border: 1px solid #4a4a4a !important;
        padding: 8px 40px 0px 8px;
    }
    .multiselect__select{
        inset-inline-end: 3px !important;
        top: 3px !important;
    }

  .video-js{
      width: 100%;
      height:100%;
  }

  .markin-markout-slider{
      margin-top: 65px;
  }

  .markin-markout-slider-wrapper {
     padding: 0 !important;
     padding-bottom: 24px !important;
  }

 .common-markinmarkout-action-btn.preview,.common-markinmarkout-action-btn.play{
      width:120px;
  }
  .common-markinmarkout-action-btn.preview{
      margin: 0 !important;
  }

  .vue-slider-rail{
    position: relative;
    z-index: 0;
  }
}
/** end v-deep override */

/** elements styles */

.filters-wrapper{
  height:50px;
  border-bottom: $secondary-border-color;
}
.video-wrapper{
    // height: calc(100% - 50px);
    position: relative;
}

div[wrappercomponent=metadata-manager] div:first-child{
   width:100%;
   height:100%;
}

.search-bar-comm-style{
  // position: absolute;
  // inset-inline-end:0px;
  .search-bar{
    background: $primary-background!important;
    height:42px;
    //width: 180px !important;
    //float: inline-start;
    width:100% !important;
    padding: 0px 12px 0 8px;
    padding-inline-start: 12px;
  }
}

.clipboardwrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: calc(100% - 40px);
    // background: $wrapper-bg-color;
    background: $secondary-background-color;
    padding: 0px 5px;

}

.disable-field{
  pointer-events: none;
}

.clipboard-card{
    margin-top: 12px;
    height: 100%;
    overflow-y: auto;
    display: inline-block;
    // justify-content: center;
    // margin-inline-end: 12px;
    width: 100%;
}

.clipboard-card ul{
    list-style: none;
    padding: 0;
    margin: 0;
}

.clipboard-card ul li {
    display: flex;
    justify-content: center;
    align-items: center;
}

.clipboard-card ul li img {
    height: 100% !important;
    object-fit: cover;
    opacity: 0.7;
}

.primary-btn-style button{
    height: 38px;
    width: 70px;
    font-size: 14px;
}

.top-nav-bar{
    background: $primary-background;
}

.active{
    background: $primary-background!important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size: 15px;
}

.nav-item{
    width: 50% !important;
}
[class*='col-']{
    padding: 0;
    margin: 0;
}
.full-width-tab{
    height: 50px;
    line-height: 44px;
    font-weight: 500;
    font-size: 16px;
    background: $secondary-background-color;
    width: 100% !important;
    border-top: $border-color;
}

.input-text-field{
    height: 38px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
}

.common-input-field{
    margin-inline-start: 2%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-fields,.mx-datepicker, textarea{
    border-radius: 3px !important;
    border: $border-color !important;
    height: 38px;
    background: $primary-background;
}

.metadata-dock-ul{
  background: $primary-background !important;
  margin-bottom: 0px !important;
}
textarea:focus{
  outline: none;
  bottom: 0px;
  inset-inline-start: 0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.markin-markout-actions-wrapper{
      padding: 0 !important;
  }

  .active-clipboardimage{
    border-color: $active-blue;
    box-shadow: 0 0 0px 3px $active-blue;
  }

  .dropdown-item:hover{
     color: $active-blue !important;
  }

  .dropdown{
      visibility:hidden;
  }

  .hide-subclips-btn{
    float: inline-end;
    height: 22px;
    width: 39px;
    font-size: 14px;
    padding: 0px;
  }

  .clipboard-card{
      ul{
          li:hover{
            .dropdown{
                visibility:visible;
            }
          }
      }
  }

  .active-clipboardname{
      color: $active-blue !important;
  }

  .add-border{
      border: $border-color;
  }
  .add-border:hover{
      border: $bg-color-on-hover;
  }

.general{
    height: 360px;
    overflow:auto;
}

.nav-link{
    text-align:center;
}

.config-desc{
    color: $dull-text-color;  
    position: relative;
    inset-inline-start: 0px;
}

.custom-control-label::before {
    background-color: transparent;
}
.comm-subclip-rows{
    display: inline-block;
    padding: 7px;
    border-radius: 4px;
    margin: 4px 8px;
    width: 97%;
    position: relative;
    background: $primary-background;
    border: $border-color!important;
}
.activeRow{
    border: 1px solid $active-blue !important;
}
.outer {
  display: table;
  position: absolute;
  top: 14%;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 50%;
  height: 138px;
  margin-bottom:10%;
  /* Whatever width you want */
  img{
    height:100%;
  }
  p{
    text-align: center;
    color: #666;
    font-size: 18px;
  }
}

.close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $bg-color-on-hover;
  border-radius: 20px;
}

.heading{
    text-align:start;
    width:80%;
    padding: 3px;
    font-size:$panel-heading-font-size;
    color:$text-color;
}
.review-id{
  color:$active-blue;
}
.context-menu{
    border-radius: 12px;
    padding: 2px;
    color: #dcdcdc;
    border: $border-color;
    border-radius: 12px;
    padding: 2px;
    background: #0000007a;
}

.context-menu:hover{
    color: #fff;
    // border: 1px solid #232323;
    // border-radius: 12px;
    // padding: 2px;
    // background: #0000007a;
}

.comments-section{
  height:100%;
  .added-comments-wrapper{
    overflow: auto;
  }
}

.history-section{
  height:100%;
}


.reply-comments-wrapper{
  //  height:calc(100% - 145px);
  // height:100%;
    overflow: auto;
}

.panel-three{
  background:$primary-background;
  border-inline-start: $secondary-border-color;
}

.button-styles{
  height: 38px;
  width: auto;
  font-size: 14px;
}

.comments-details-wrapper{
  display: inline-flex;
  color:$dull-text-color;
  // width: 55%;
  width:70%;
  justify-content:flex-end;
  font-size: 13px;
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    border-inline-end: $border-color;
    img{
        height:100%;
        width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}

.edit-icon{
    visibility: hidden;
}

.edit-icon-visibility{
    width: 100%;
}

.edit-icon-visibility:hover{
    .edit-icon{
        visibility: visible;
    } 
}


.description-edit-icon-visibility:hover{
  .description-options-wrapper{
    visibility: visible;
  }
}

.description-options-wrapper{
    visibility: hidden;
    position: absolute;
    inset-inline-end: 10px;
    top: 4px;
    border: 1px solid #5a5a5a;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    svg{
       width: 22px;
        height: 22px;
        padding: 3px;
        // margin: 3px 0px 3px 3px;
        border-radius: 4px;
    }
}

.preview-tag-main-wrapper:hover{
  .url-preview-delete-icon{
    visibility:visible;
  } 
}

.preview-tag-main-wrapper{
  display:inline-block;
  width:100%;
  align-items:center;
  .preview-tag-div{
    display: inline-block;
    max-width: 95%;
    float: inline-start;
  }
}

.url-preview-delete-icon{
    // border: 1px solid #5a5a5a;
    visibility:hidden;
    width: 30px;
    display: inline-block !important;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    position: relative;
    top:12px;
    svg{
       width: 22px;
        height: 22px;
        padding: 3px;
        // margin: 3px 0px 3px 3px;
        border-radius: 4px;
    }
}

[v-cloak] .hide-element-util-mount{ //sometimes un-necessary preview dialog was showing to hide code is required
  display: none;
}
.hide{display:none;}

.share-in-chat-styles{
  position:relative;
  inset-inline-start:-14px;
}

.share-in-chat-styles:hover{
    border-radius: 0px;
  }

  .each-history-main-wrapper{
    border-bottom: 1px solid #2b2b2b;
    padding: 8px 5px;
    position: relative !important;
    .summary-div{
      display: inline-flex;
      align-items: center;
      padding:0px 10px 10px 10px;
      .summary-data-div{
        font-size: 16px;
      }
      .date-lael{
        color: $secondary-text-color;
        margin-inline-start:10px;
        font-size:12px;
      }
    }
    .detailed-information-wrapper{
      padding:0px 10px 10px 10px;
      color:#c6c6c6;
      pre{
        color:#c6c6c6 !important;
        font-family: "Roboto", Arial, sans-serif !important;
      }
    }
  } 
  
  .user-name-or-image{
    top:0px !important;
  }

// .minimised-player{
//   bottom: 4% !important;
// }
</style>